import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models";
import {
	IRQReportListModel,
	IRQReportPayloadModel,
} from "../models/reports/RQReport";
import {
	ISalaryProfileReportListModel,
	ISalaryProfileReportPayloadModel,
} from "../models/reports/salaryProfileReport";

import { ICRAReportListModel } from "../models/reports/CRAReport";
import { IDropDownListResponse } from "../models/common/IDropDownListResponse";
import { IEDRReportListModel } from "../models/reports/EDRReport";
import { IEmployeeReportListModel } from "../models/reports/employeeReport";
import { IInvoiceReportListModel } from "../models/reports";
import { IPayrollAdjustmentReportListModel } from "../models/reports/payrollAdjustmentReport";
import { IRL1ReportListModel } from "../models/reports/rl1Report";
import { IROEReportModel } from "../models/reports/ROEReport";
import { IStatutoryHolidayReportListModel } from "../models/reports/StatutoryHolidayReport";
import { IT4AReportListModel } from "../models/reports/t4aReport/t4aReport";
import { IT4ReportListModel } from "../models/reports/t4Report";
import { ITD1ReportModel } from "../models/reports/TD1Report";
import { ITimeSheetReportListModel } from "../models/reports/timeSheetReport";
import { IWSIBReportListModel } from "../models/reports/WSIBReport";
import { IYearToDateReportModel } from "../models/reports/YearToDateReport";
import { format422Errors } from "../common/Common";
import http from "../common/http-commons";
import { IVacationPayReportListModel } from "../models/reports/VacationPayReport";

// TODO: replace this with API response once it's ready
export const ReportsService = {
	getInvoiceAdminReport: async (
		params: IGetListRequest,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		const fixedResponse: any = {
			page: 1,
			size: 50,
			total: 2,
			items: [
				{
					client: "61a8267d-3770-475d-b4e7-f8307ca4ec95",
					invoiceNo: "INV00001",
					refNo: "UPI00001",
					year: 2019,
					invAmount: 63,
					taxes: 12,
					handlingCharges: 2.79,
					discount: 4,
					netAmount: 73.79,
					invoiceDate: "2023-09-21",
					paidAmount: 73.79,
					paymentDate: "2023-09-21",
					refund: null,
					status: true,
					code: "pay",
					clientName: "payment_method",
				},
				{
					client: "5fd55a4f-f262-4a4b-acd1-84acb310a305",
					invoiceNo: "Not Assigned",
					refNo: "UPI00002",
					year: 2020,
					invAmount: 50,
					taxes: 10,
					handlingCharges: 2.79,
					discount: 4,
					netAmount: 65.79,
					invoiceDate: "2023-09-15",
					paidAmount: 60.79,
					paymentDate: "2023-09-21",
					refund: null,
					status: false,
					code: "abc",
					clientName: "abc name",
				},
			],
			keyField: {
				field: "employee",
				templateUrl: "/compliance/t4/setup/id",
			},
			headerColumns: [
				{
					field: "clientName",
					headerName: "Client",
					description: "Client",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 0,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "invoiceNo",
					headerName: "invoice No.",
					description: "invoice No",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 2,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "refNo",
					headerName: "Ref. No.",
					description: "Ref No",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 3,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "year",
					headerName: "Year",
					description: "Year",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 4,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "invAmount",
					headerName: "Inv. Amount",
					description: "Inv Amount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 5,
					frozenColumn: false,
					footer: 113,
				},
				{
					field: "taxes",
					headerName: "Taxes",
					description: "Taxes",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 6,
					frozenColumn: false,
					footer: 22,
				},
				{
					field: "handlingCharges",
					headerName: "Handling Charges",
					description: "Handling Charges",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 7,
					frozenColumn: false,
					footer: 5,
				},
				{
					field: "discount",
					headerName: "Discount",
					description: "Discount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 8,
					frozenColumn: false,
					footer: 8,
				},
				{
					field: "netAmount",
					headerName: "Net Amount",
					description: "Net Amount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 9,
					frozenColumn: false,
					footer: 139,
				},
				{
					field: "invoiceDate",
					headerName: "Invoice Date",
					description: "Invoice Date",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 10,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "paidAmount",
					headerName: "Paid Amount",
					description: "Paid Amount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 11,
					frozenColumn: false,
					footer: 134,
				},
				{
					field: "paymentDate",
					headerName: "Payment Date",
					description: "Payment Date",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 12,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "refund",
					headerName: "Refund",
					description: "Refund",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 13,
					frozenColumn: false,
					footer: 0,
				},
				{
					field: "status",
					headerName: "Status",
					description: "Status",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 14,
					frozenColumn: false,
					footer: null,
				},
			],
		};
		return new Promise((resolve) =>
			setTimeout(() => resolve(fixedResponse), 1000),
		);

		// const response: AxiosResponse<IDataRoleListModel> = await http.get<IDataRoleListModel>(
		//   `/v1/data-roles/?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);

		// if (response.status === 200) {
		//   return response.data;
		// } else if (response.status === 400) {
		//   return {
		//     status: false,
		//     message: "Bad Request.",
		//     error: true,
		//   };
		// } else if (response.status === 500) {
		//   return {
		//     status: false,
		//     message: "Something went wrong.",
		//     error: true,
		//   };
		// }

		// return {
		//   status: false,
		//   message: "Something went wrong please try again later.",
		// };
	},
	getInvoiceAdminReport1: async (
		startDate: string,
		endDate: string,
		dateAppliesTo: number,
		paymentStatus: number,
		params: any,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/billing-calculation/super-user?start_date=${startDate}&end_date=${endDate}&payment_status=${paymentStatus}&date_applies_to=${dateAppliesTo}&select_invoice=20&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getActivityLogReport: async (
		startDate: string,
		endDate: string,
		screen: string,
		user: string,
		activityType: string,
		clientName: any,
		params: any,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/activity-log/activty-log/report-screen/?order_by=${
				params.order_by
			}&order_direction=${params.order_direction}&page=${params.page}&size=${
				params.size
			}&start_date=${startDate} 00:00:00&end_date=${endDate} 00:00:00${
				screen !== "all" ? `&slug=${screen}` : ""
			}&variable_value=${clientName}&activity_type=${
				activityType !== "all" ? activityType : ""
			}`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 2,
		//   items: [
		//     {
		//       activityType: "T4Slip Emailed",
		//       data: "DEEPAK KHOSLA 2023 (Completed)",
		//       updatedBy: "Mirza Idrees",
		//       updatedOn: "Feb 28, 2024",
		//     },
		//     {
		//       activityType: "T4Slip Emailed",
		//       data: "ZEESHAN MALIK 2023 (Completed)",
		//       updatedBy: "Mirza Idrees",
		//       updatedOn: "Mar 03, 2024",
		//     },
		//   ],
		//   keyField: {
		//     field: "employee",
		//     templateUrl: "/compliance/t4/setup/id",
		//   },
		//   headerColumns: [
		//     {
		//       //only this column have sortable true
		//       field: "activityType",
		//       headerName: "Activity Type",
		//       description: "Activity Type",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 0,
		//       frozenColumn: false,
		//       footer: null,
		//     },
		//     {
		//       field: "data",
		//       headerName: "Data",
		//       description: "Data",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: null,
		//     },
		//     {
		//       field: "updatedBy",
		//       headerName: "Updated By",
		//       description: "Updated By",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: null,
		//     },
		//     {
		//       field: "updatedOn",
		//       headerName: "Updated On",
		//       description: "Updated On",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: null,
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );
	},
	delAdminInvoices: async (
		payload: any,
	): Promise<string | IServerError | IResponse> => {
		// return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
		const response: AxiosResponse<string> | any = await http.delete<string>(
			`/v1/billing-calculation/bulk-delete/`,
			{ data: payload },
		);

		if (response.status === 200) {
			return response;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getJournalExport: async (
		params: IGetListRequest,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		const fixedResponse: any = {
			page: 1,
			size: 50,
			total: 2,
			items: [
				{
					client: "f17badd1-ea46-415c-8bb8-59363b8e3f4c",
					invoiceNo: "INV00001",
					refNo: "UPI00001",
					year: 2019,
					invAmount: 63,
					taxes: 12,
					handlingCharges: 2.79,
					discount: 4,
					netAmount: 73.79,
					invoiceDate: "2023-09-21",
					paidAmount: 73.79,
					paymentDate: "2023-09-21",
					refund: null,
					status: true,
					code: "pay",
					clientName: "payment_method",
				},
				{
					client: "15e3106f-e942-4c91-a63f-5b67affc6c78",
					invoiceNo: "not assigned",
					refNo: "UPI00002",
					year: 2020,
					invAmount: 50,
					taxes: 10,
					handlingCharges: 2.79,
					discount: 4,
					netAmount: 65.79,
					invoiceDate: "2023-09-15",
					paidAmount: 60.79,
					paymentDate: "2023-09-21",
					refund: null,
					status: false,
					code: "abc",
					clientName: "abc name",
				},
			],
			keyField: {
				field: "employee",
				templateUrl: "/compliance/t4/setup/id",
			},
			headerColumns: [
				{
					field: "clientName",
					headerName: "Client",
					description: "Client",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 0,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "invoiceNo",
					headerName: "invoice No.",
					description: "invoice No",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 2,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "refNo",
					headerName: "Ref. No.",
					description: "Ref No",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 3,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "year",
					headerName: "Year",
					description: "Year",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 4,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "invAmount",
					headerName: "Inv. Amount",
					description: "Inv Amount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 5,
					frozenColumn: false,
					footer: 113,
				},
				{
					field: "taxes",
					headerName: "Taxes",
					description: "Taxes",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 6,
					frozenColumn: false,
					footer: 22,
				},
				{
					field: "handingCharges",
					headerName: "Handing Charges",
					description: "Handing Charges",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 7,
					frozenColumn: false,
					footer: 5,
				},
				{
					field: "discount",
					headerName: "Discount",
					description: "Discount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 8,
					frozenColumn: false,
					footer: 8,
				},
				{
					field: "netAmount",
					headerName: "Net Amount",
					description: "Net Amount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 9,
					frozenColumn: false,
					footer: 139,
				},
				{
					field: "invoiceDate",
					headerName: "Invoice Date",
					description: "Invoice Date",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 10,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "paidAmount",
					headerName: "Paid Amount",
					description: "Paid Amount",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 11,
					frozenColumn: false,
					footer: 134,
				},
				{
					field: "paymentDate",
					headerName: "Payment Date",
					description: "Payment Date",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 12,
					frozenColumn: false,
					footer: null,
				},
				{
					field: "refund",
					headerName: "Refund",
					description: "Refund",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 13,
					frozenColumn: false,
					footer: 0,
				},
				{
					field: "status",
					headerName: "Status",
					description: "Status",
					flex: 1,
					hide: false,
					hideable: false,
					sortable: true,
					sortingOrder: "asc",
					resizable: false,
					type: "string",
					align: "left",
					headerAlign: "left",
					hideSortIcons: false,
					disableColumnMenu: true,
					disableReorder: true,
					disableExport: true,
					maskable: false,
					isFixed: true,
					sequence: 14,
					frozenColumn: false,
					footer: null,
				},
			],
		};
		return new Promise((resolve) =>
			setTimeout(() => resolve(fixedResponse), 1000),
		);

		// const response: AxiosResponse<IDataRoleListModel> = await http.get<IDataRoleListModel>(
		//   `/v1/data-roles/?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);

		// if (response.status === 200) {
		//   return response.data;
		// } else if (response.status === 400) {
		//   return {
		//     status: false,
		//     message: "Bad Request.",
		//     error: true,
		//   };
		// } else if (response.status === 500) {
		//   return {
		//     status: false,
		//     message: "Something went wrong.",
		//     error: true,
		//   };
		// }

		// return {
		//   status: false,
		//   message: "Something went wrong please try again later.",
		// };
	},
	getJournalExport1: async (
		startDate: string,
		endDate: string,
		dateAppliesTo: number,
		paymentStatus: number,
		selectInvoice: number,
		params: any,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/billing-calculation/super-user?start_date=${startDate}&end_date=${endDate}&payment_status=${paymentStatus}&date_applies_to=${dateAppliesTo}&select_invoice=${selectInvoice}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	createInvoice: async (
		clientId: string,
		taxYear: Number,
	): Promise<IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.post<any>(
			`/v1/billing-calculation/?client_id=${clientId}&tax_year=${taxYear}`,
		);

		if (response.status === 201) {
			return response.data;
		} else if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getPreviousYearInvoice: async (
		clientId: string,
		taxYear: Number,
	): Promise<IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/billing-calculation/get_previous_year_invoice/?client_id=${clientId}&tax_year=${taxYear}`,
		);

		if (response.status === 201) {
			return response.data;
		} else if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getInvoiceReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		startDate: string | null,
		endDate: string | null,
		params: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<any | IServerError | IResponse> => {
		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 1,
		//   items: [
		//     {
		//       invoiceNo: "INV00124",
		//       refNo: "UPI00156",
		//       invAmount: 37.0,
		//       netAmount: 40.32,
		//       invoiceDate: "2025-12-15",
		//       paidAmount: 40.32,
		//       paymentDate: "2025-12-15",
		//       tax: 1.85,
		//       paid: true,
		//       discount: 0.0,
		//       handlingCharges: 1.47,
		//       id: "693fab6f6da490b5fe83b84e",
		//     },
		//     {
		//       invoiceNo: "Not Assigned",
		//       refNo: "UPI00167",
		//       invAmount: 21.0,
		//       netAmount: 23.02,
		//       invoiceDate: "2026-01-09",
		//       paidAmount: 23.02,
		//       paymentDate: null,
		//       tax: 1.05,
		//       paid: false,
		//       discount: 0.0,
		//       handlingCharges: 0.97,
		//       id: "6960e3f5787ce755017d41ab",
		//     },
		//   ],
		//   keyField: {
		//     field: "invoiceNo",
		//     templateUrl: "/reports/invoice-detail",
		//   },
		//   headerColumns: [
		//     {
		//       field: "invoiceNo",
		//       headerName: "Invoice No",
		//       description: "Invoice No",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 0,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "invAmount",
		//       headerName: "Inv amount",
		//       description: "Inv amount",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 1,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "tax",
		//       headerName: "Taxes",
		//       description: "Taxes",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "handlingCharges",
		//       headerName: "Handling Charges",
		//       description: "handling Charges",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "netAmount",
		//       headerName: "Net Amount",
		//       description: "Net Amount",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "invoiceDate",
		//       headerName: "Invoice Date",
		//       description: "Invoice Date",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 5,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "paidAmount",
		//       headerName: "Paid Amount",
		//       description: "Paid Amount",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 6,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "paymentDate",
		//       headerName: "Payment Date",
		//       description: "payment Date",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 7,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "paid",
		//       headerName: "Status",
		//       description: "Status",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: false,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 8,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );
		if (!runGetListAPICall || !startDate || !endDate) return null;
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/billing-calculation/invoice-list/${clientId}/?start_date=${startDate}&end_date=${endDate}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getUpdateInvoice: async (
		refNo: string,
	): Promise<any | IServerError | IResponse> => {
		if (refNo !== "") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/billing-calculation/${refNo}/ref-no/`,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 404) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},
	getUpdateInvoiceDDL: async (): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/billing-calculation/`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getInvoiceTransactionDetail: async (
		clientId: string,
		taxYear: number,
		invoiceNo: string,
		params?: IGetListRequest,
	): Promise<any | IServerError | IResponse> => {
		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 5,
		//   items: [
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "2 2",
		//       description: "T4A Slip Charged",
		//       province: "ON",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 3.0,
		//       id: "0",
		//     },
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "Demo12 Employee12",
		//       description: "T4A Slip Charged",
		//       province: "ON",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 6.0,
		//       id: "1",
		//     },
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "T4 A",
		//       description: "T4A Slip Charged",
		//       province: "AB",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 9.0,
		//       id: "2",
		//     },
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "Zeeshan Vendor",
		//       description: "T4A Slip Charged",
		//       province: "AB",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 12.0,
		//       id: "3",
		//     },
		//     {
		//       transactionType: "T4A Summary",
		//       employee: "N/A",
		//       description: "T4A Summary Charged",
		//       province: "N/A",
		//       transactionDate: "2025-12-15",
		//       amount: 25.0,
		//       accumulatedTotal: 37.0,
		//       id: "693fab3c6da490b5fe83b833",
		//     },
		//   ],
		//   sumData: [
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Total Amount",
		//       accumulatedTotal: 37.0,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Tax Amount(GST: 5.00%)",
		//       accumulatedTotal: 1.85,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Discount Amount",
		//       accumulatedTotal: 0.0,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Handling Charges",
		//       accumulatedTotal: 1.47,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Net Amount",
		//       accumulatedTotal: 40.32,
		//       id: "",
		//     },
		//   ],
		//   keyField: {
		//     field: "employee",
		//     templateUrl: "/",
		//   },
		//   headerColumns: [
		//     {
		//       field: "transactionType",
		//       headerName: "Transaction Type",
		//       description: "Transaction Type",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 0,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "employee",
		//       headerName: "Employee",
		//       description: "Employee",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 1,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "province",
		//       headerName: "Province",
		//       description: "Province",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "description",
		//       headerName: "Description",
		//       description: "Description",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "transactionDate",
		//       headerName: "Transaction Date",
		//       description: "Transaction Date",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "amount",
		//       headerName: "Amount",
		//       description: "Amount",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 5,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "accumulatedTotal",
		//       headerName: "Accumulated Total",
		//       description: "Accumulated Total",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 6,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );

		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/transaction-log/by-invoice-detail?client_id=${clientId}&invoice_id=${invoiceNo}&order_by=name&order_direction=asc&page=1&size=50`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getInvoiceUnchargedTransaction: async (
		clientId: string,
		taxYear: number,
		type: any,
	): Promise<any | IServerError | IResponse> => {
		// const fixedResponse: any = {
		//   page: 1,
		//   size: 50,
		//   total: 5,
		//   items: [
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "2 2",
		//       description: "T4A Slip Charged",
		//       province: "ON",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 3.0,
		//       id: "0",
		//     },
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "Demo12 Employee12",
		//       description: "T4A Slip Charged",
		//       province: "ON",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 6.0,
		//       id: "1",
		//     },
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "T4 A",
		//       description: "T4A Slip Charged",
		//       province: "AB",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 9.0,
		//       id: "2",
		//     },
		//     {
		//       transactionType: "T4A Slip",
		//       employee: "Zeeshan Vendor",
		//       description: "T4A Slip Charged",
		//       province: "AB",
		//       transactionDate: "2025-12-15",
		//       amount: 3.0,
		//       accumulatedTotal: 12.0,
		//       id: "3",
		//     },
		//     {
		//       transactionType: "T4A Summary",
		//       employee: "N/A",
		//       description: "T4A Summary Charged",
		//       province: "N/A",
		//       transactionDate: "2025-12-15",
		//       amount: 25.0,
		//       accumulatedTotal: 37.0,
		//       id: "693fab3c6da490b5fe83b833",
		//     },
		//   ],
		//   sumData: [
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Total Amount",
		//       accumulatedTotal: 37.0,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Tax Amount(GST: 5.00%)",
		//       accumulatedTotal: 1.85,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Discount Amount",
		//       accumulatedTotal: 0.0,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Handling Charges",
		//       accumulatedTotal: 1.47,
		//       id: "",
		//     },
		//     {
		//       transactionType: "",
		//       employee: "",
		//       description: "",
		//       province: "",
		//       transactionDate: "",
		//       amount: "Net Amount",
		//       accumulatedTotal: 40.32,
		//       id: "",
		//     },
		//   ],
		//   keyField: {
		//     field: "employee",
		//     templateUrl: "/",
		//   },
		//   headerColumns: [
		//     {
		//       field: "transactionType",
		//       headerName: "Transaction Type",
		//       description: "Transaction Type",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 0,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "employee",
		//       headerName: "Employee",
		//       description: "Employee",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 1,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "province",
		//       headerName: "Province",
		//       description: "Province",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "description",
		//       headerName: "Description",
		//       description: "Description",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "transactionDate",
		//       headerName: "Transaction Date",
		//       description: "Transaction Date",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "amount",
		//       headerName: "Amount",
		//       description: "Amount",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 5,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//     {
		//       field: "accumulatedTotal",
		//       headerName: "Accumulated Total",
		//       description: "Accumulated Total",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 6,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: null,
		//       alignFrozen: null,
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );

		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/transaction-log/?client_id=${clientId}&order_by=name&order_direction=asc&page=1&size=50`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getInvoiceDetail: async (
		clientId: string,
		refNo: string,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		//   const fixedResponse: any = {
		//     'createdByEmail': 'umair@taxslips.ca',
		//     'createdByExternalId': 23,
		//     'createdAt': '2023-06-08T15:02:54.911217',
		//     'client': {'externalId': '46f7b880-624c-4635-a845-24a20c4a75c8'},
		//     'taxYear': 2022,
		//     'id': '6481a74e67d820a15dc2c536',
		//     'detail': [
		//         {
		//           'product': 'T4 slips',
		//           'quantity': 3,
		//           'unitPrice': 4.0,
		//           'amount': 12.0
		//         },
		//         {
		//           'product': 'RL1 slips',
		//           'quantity': 0,
		//           'unitPrice': 0.0,
		//           'amount': 0.0
		//         },
		//         {
		//           'product': 'T4a slips',
		//           'quantity': 0,
		//           'unitPrice': 0.0,
		//           'amount': 0.0
		//         }
		//     ],
		//     'totalAmount': 12.0,
		//     'taxAmount': 3.0,
		//     'invoiceNo': 'INV00009',
		//     'refNo': 'UPI00009',
		//     'discount': 0.0,
		//     'handlingCharges': 0.0,
		//     'netAmount': 15.0
		// }
		//   return new Promise(resolve => setTimeout(() => resolve(fixedResponse), 1000));

		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/billing-calculation/ref-no/${refNo}/?client_id=${clientId}`,
		);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	paypalIntegrationOfUnpaidInvoice: async (
		clientId: string,
		refNo: string,
		tag: string,
	): Promise<IInvoiceReportListModel | IServerError | IResponse> => {
		if (tag === "paypal") {
			const response: AxiosResponse<any> = await http.post<any>(
				`/v1/paypal-integration/?client_id=${clientId}&ref_no=${refNo}`,
			);

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} else {
			const response: AxiosResponse<any> = await http.post<any>(
				`/v1/paypal-integration/stripe/${clientId}/?ref_no=${refNo}`,
			);

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		}
		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	// comment old getEmployeeReport
	// getEmployeeReport: async (
	// 	clientId: string,
	// 	params: IGetListRequest,
	// navigateToLogout
	// ): Promise<IEmployeeReportListModel | IServerError | IResponse> => {
	// 	//       const fixedResponse: any = {
	// 	//     "page": 1,
	// 	//     "size": 50,
	// 	//     "total": 2,
	// 	//     "items": [
	// 	//         {
	// 	//             "id": "52058dd1-da26-4cfb-b07a-cada80c1bda3",
	// 	//             "firstName": "test Rl1",
	// 	//             "lastName": "Ali",
	// 	//             "uniqueIdentifier": "123456789",
	// 	//             "email": "zeeshan123@gmail.com",
	// 	//             "createdDate": "2023-07-03",
	// 	//             "businessName": null,
	// 	//             "businessNumber": null,
	// 	//             "status": "Active",
	// 	//             "address": {
	// 	//                 "id": "7262d99a-793a-47ec-848e-1c0396d36f6f",
	// 	//                 "isPrimary": true,
	// 	//                 "appAddressTypeId": 1,
	// 	//                 "addressLine1": "testing",
	// 	//                 "addressLine2": null,
	// 	//                 "city": "dfdf",
	// 	//                 "postalCode": "A5d5d5",
	// 	//                 "province": {
	// 	//                     "id": 5,
	// 	//                     "name": "NewfoundLand & Labrador",
	// 	//                     "shortCode": "NL"
	// 	//                 },
	// 	//                 "country": {
	// 	//                     "id": 1,
	// 	//                     "name": "Canada",
	// 	//                     "shortCode": "CAN"
	// 	//                 }
	// 	//             },
	// 	//             "metaFields": {
	// 	//                 "name_0": "INITIALS",
	// 	//                 "value_0": "None",
	// 	//                 "name_1": "DATE_OF_BIRTH",
	// 	//                 "value_1": "Z",
	// 	//                 "name_2": "PROVINCE_OF_EMPLOYMENT",
	// 	//                 "value_2": "id=11 name='Quebec' short_code='QC'"
	// 	//             },
	// 	//             "bankAccounts": []
	// 	//         },
	// 	//         {
	// 	//             "id": "3d365ce1-40af-4ec2-bfc6-178a9e929de5",
	// 	//             "firstName": "Zeeshan",
	// 	//             "lastName": "Ali",
	// 	//             "uniqueIdentifier": "123456789",
	// 	//             "email": "waqas123@gmail.com",
	// 	//             "createdDate": "2023-07-03",
	// 	//             "businessName": null,
	// 	//             "businessNumber": null,
	// 	//             "status": "Active",
	// 	//             "address": {
	// 	//                 "id": "96295d01-3ea1-494f-84cc-4031d1ce6979",
	// 	//                 "isPrimary": true,
	// 	//                 "appAddressTypeId": 1,
	// 	//                 "addressLine1": "testing",
	// 	//                 "addressLine2": null,
	// 	//                 "city": "dfdf",
	// 	//                 "postalCode": "A5d5d5",
	// 	//                 "province": {
	// 	//                     "id": 8,
	// 	//                     "name": "Nunavut",
	// 	//                     "shortCode": "NU"
	// 	//                 },
	// 	//                 "country": {
	// 	//                     "id": 1,
	// 	//                     "name": "Canada",
	// 	//                     "shortCode": "CAN"
	// 	//                 }
	// 	//             },
	// 	//             "metaFields": {
	// 	//                 "name_0": "PPIP_EXEMPT",
	// 	//                 "value_0": "False",
	// 	//                 "name_1": "PROVINCE_OF_EMPLOYMENT",
	// 	//                 "value_1": "id=7 name='Northwest Territories' short_code='NT'",
	// 	//                 "name_2": "REDUCED_EI",
	// 	//                 "value_2": "False",
	// 	//                 "name_3": "EI_EXEMPT",
	// 	//                 "value_3": "True",
	// 	//                 "name_4": "CPP_QPP_EXEMPT",
	// 	//                 "value_4": "True",
	// 	//                 "name_5": "EMPLOYMENT_CODE",
	// 	//                 "value_5": "EmploymentCode.TAXI_DRIVERS_DRIVERS_OF_OTHER_PASSENGER_CARRYING_VEHICALS",
	// 	//                 "name_6": "PAY_PERIOD",
	// 	//                 "value_6": "PayPeriods.BI_WEEKLY_26"
	// 	//             },
	// 	//             "bankAccounts": []
	// 	//         }
	// 	//     ],
	// 	//     "keyField": {
	// 	//         "field": "name",
	// 	//         "templateUrl": "/employees-report/{id}"
	// 	//     },
	// 	//     "headerColumns": [
	// 	//         {
	// 	//             "field": "firstName",
	// 	//             "headerName": "Name",
	// 	//             "description": "Name",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 0
	// 	//         },
	// 	//         {
	// 	//             "field": "status",
	// 	//             "headerName": "Status",
	// 	//             "description": "status",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 1
	// 	//         },
	// 	//         {
	// 	//             "field": "uniqueIdentifier",
	// 	//             "headerName": "Unique Identifier",
	// 	//             "description": "unique Identifier",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 2
	// 	//         },
	// 	//         {
	// 	//             "field": "email",
	// 	//             "headerName": "Email",
	// 	//             "description": "Email",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 3
	// 	//         },
	// 	//         {
	// 	//             "field": "address.addressLine1",
	// 	//             "headerName": "Address",
	// 	//             "description": "Address",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 4
	// 	//         },
	// 	//         {
	// 	//             "field": "address.city",
	// 	//             "headerName": "City",
	// 	//             "description": "City",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 5
	// 	//         },
	// 	//         {
	// 	//             "field": "address.postalCode",
	// 	//             "headerName": "Postal Code",
	// 	//             "description": "postal Code",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 6
	// 	//         },
	// 	//         {
	// 	//             "field": "address.province.name",
	// 	//             "headerName": "Province",
	// 	//             "description": "province",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 7
	// 	//         },
	// 	//         {
	// 	//             "field": "metaFields.value_0",
	// 	//             "headerName": "metaFields.name_0",
	// 	//             "description": "INITIALS",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 8
	// 	//         },
	// 	//         {
	// 	//             "field": "metaFields.value_1",
	// 	//             "headerName": "DATE_OF_BIRTH",
	// 	//             "description": "DATE_OF_BIRTH",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 9
	// 	//         },
	// 	//         {
	// 	//             "field": "metaFields.value_2",
	// 	//             "headerName": "PROVINCE_OF_EMPLOYMENT",
	// 	//             "description": "PROVINCE_OF_EMPLOYMENT",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 10
	// 	//         },
	// 	//         // {
	// 	//         //     "field": "metaFields.value_0",
	// 	//         //     "headerName": "PPIP_EXEMPT",
	// 	//         //     "description": "PPIP_EXEMPT",
	// 	//         //     "flex": 1,
	// 	//         //     "hide": false,
	// 	//         //     "hideable": false,
	// 	//         //     "sortable": true,
	// 	//         //     "sortingOrder": "asc",
	// 	//         //     "resizable": false,
	// 	//         //     "type": "string",
	// 	//         //     "align": "left",
	// 	//         //     "headerAlign": "left",
	// 	//         //     "hideSortIcons": false,
	// 	//         //     "disableColumnMenu": true,
	// 	//         //     "disableReorder": true,
	// 	//         //     "disableExport": true,
	// 	//         //     "maskable": false,
	// 	//         //     "isFixed": true,
	// 	//         //     "sequence": 11
	// 	//         // },
	// 	//         // {
	// 	//         //     "field": "metaFields.value_1",
	// 	//         //     "headerName": "PROVINCE_OF_EMPLOYMENT",
	// 	//         //     "description": "PROVINCE_OF_EMPLOYMENT",
	// 	//         //     "flex": 1,
	// 	//         //     "hide": false,
	// 	//         //     "hideable": false,
	// 	//         //     "sortable": true,
	// 	//         //     "sortingOrder": "asc",
	// 	//         //     "resizable": false,
	// 	//         //     "type": "string",
	// 	//         //     "align": "left",
	// 	//         //     "headerAlign": "left",
	// 	//         //     "hideSortIcons": false,
	// 	//         //     "disableColumnMenu": true,
	// 	//         //     "disableReorder": true,
	// 	//         //     "disableExport": true,
	// 	//         //     "maskable": false,
	// 	//         //     "isFixed": true,
	// 	//         //     "sequence": 12
	// 	//         // },
	// 	//         // {
	// 	//         //     "field": "metaFields.value_2",
	// 	//         //     "headerName": "REDUCED_EI",
	// 	//         //     "description": "REDUCED_EI",
	// 	//         //     "flex": 1,
	// 	//         //     "hide": false,
	// 	//         //     "hideable": false,
	// 	//         //     "sortable": true,
	// 	//         //     "sortingOrder": "asc",
	// 	//         //     "resizable": false,
	// 	//         //     "type": "string",
	// 	//         //     "align": "left",
	// 	//         //     "headerAlign": "left",
	// 	//         //     "hideSortIcons": false,
	// 	//         //     "disableColumnMenu": true,
	// 	//         //     "disableReorder": true,
	// 	//         //     "disableExport": true,
	// 	//         //     "maskable": false,
	// 	//         //     "isFixed": true,
	// 	//         //     "sequence": 13
	// 	//         // },
	// 	//         {
	// 	//             "field": "metaFields.value_3",
	// 	//             "headerName": "EI_EXEMPT",
	// 	//             "description": "EI_EXEMPT",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 14
	// 	//         },
	// 	//         {
	// 	//             "field": "metaFields.value_4",
	// 	//             "headerName": "CPP_QPP_EXEMPT",
	// 	//             "description": "CPP_QPP_EXEMPT",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 15
	// 	//         },
	// 	//         {
	// 	//             "field": "metaFields.value_5",
	// 	//             "headerName": "EMPLOYMENT_CODE",
	// 	//             "description": "EMPLOYMENT_CODE",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 16
	// 	//         },
	// 	//         {
	// 	//             "field": "metaFields.value_6",
	// 	//             "headerName": "PAY_PERIOD",
	// 	//             "description": "PAY_PERIOD",
	// 	//             "flex": 1,
	// 	//             "hide": false,
	// 	//             "hideable": false,
	// 	//             "sortable": true,
	// 	//             "sortingOrder": "asc",
	// 	//             "resizable": false,
	// 	//             "type": "string",
	// 	//             "align": "left",
	// 	//             "headerAlign": "left",
	// 	//             "hideSortIcons": false,
	// 	//             "disableColumnMenu": true,
	// 	//             "disableReorder": true,
	// 	//             "disableExport": true,
	// 	//             "maskable": false,
	// 	//             "isFixed": true,
	// 	//             "sequence": 17
	// 	//         }
	// 	//     ]
	// 	// }
	// 	//       return new Promise(resolve => setTimeout(() => resolve(fixedResponse), 1000));
	//
	// 	const response: AxiosResponse<any> = await http.get<any>(
	// 		`/v1/vendors-employee-report/employee/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`
	// 	);
	// 	// `/v1/vendors-employee-report/vendors/?client_id=${clientId}
	// 	// &order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}
	// 	// `);

	// 	if (response.status === 200) {
	// 		return response.data;
	// 	} else if (response.status === 400) {
	// 		return {
	// 			status: false,
	// 			message: "Bad Request.",
	// 			error: true,
	// 		};
	// 	} else if (response.status === 500) {
	// 		return {
	// 			status: false,
	// 			message: "Something went wrong.",
	// 			error: true,
	// 		};
	// 	}

	// 	return {
	// 		status: false,
	// 		message: "Something went wrong please try again later.",
	// 	};
	// },

	// ============

	getEmployeeReport: async (
		runGetListAPICall: boolean,
		clientId: string,

		payFrequency: string | number,
		employeeStatus: string | number,
		payMethod: string | number,
		provinceOfEmployment: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IEmployeeReportListModel | IServerError | IResponse | null> => {
		if (payFrequency && runGetListAPICall) {
			try {
				const response: AxiosResponse<IEmployeeReportListModel> =
					await http.get<IEmployeeReportListModel>(
						"/v1/employees/report/?client_id=" +
							clientId +
							"&pay_frequency=" +
							payFrequency +
							"&employee_status=" +
							employeeStatus +
							"&pay_method=" +
							payMethod +
							"&province_of_employment=" +
							provinceOfEmployment +
							"&order_by=" +
							data.order_by +
							"&order_direction=" +
							data.order_direction +
							"&page=" +
							data.page +
							"&size=" +
							data.size +
							"&search_query=" +
							data.search_query,
					);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		} else {
			return null;
		}
	},

	submitEmployeeReportAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<IEmployeeReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IEmployeeReportListModel> =
				await http.put<IEmployeeReportListModel>(
					`/v1/employees/report-header-columns?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getEmployeeBasedProvincesOfEmploymentDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/employees/provinces-ddl?client_id=${clientId}`,
		);
		if (response.status === 200) {
			return response.data;
		}
		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getSalaryProfileReport: async (
		runGetListAPICall: boolean,
		clientId: string,

		employeeStatus: string | number,
		employeeId: string,
		startDate: string | null,
		endDate: string | null,
		dateRange: boolean,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		ISalaryProfileReportListModel | IServerError | IResponse | null
	> => {
		if (!runGetListAPICall || !employeeId) return null;
		try {
			const response: AxiosResponse<ISalaryProfileReportListModel> =
				await http.get<ISalaryProfileReportListModel>(
					"/v1/salary-profile-report/?client_id=" +
						clientId +
						"&employee_status=" +
						employeeStatus +
						"&employee_id=" +
						employeeId +
						(dateRange && startDate ? "&start_date=" + startDate : "") +
						(dateRange && endDate ? "&end_date=" + endDate : "") +
						"&date_range=" +
						(dateRange ? "true" : "false") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getSalaryProfileAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<ISalaryProfileReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ISalaryProfileReportListModel> =
				await http.put<ISalaryProfileReportListModel>(
					`/v1/salary-profile-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getCRAReport: async (
		remittanceFrequencyId: null | { label: string; value: string },
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<ICRAReportListModel | IServerError | IResponse | null | any> => {
		// 	const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 12,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 1000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					csstAmount: 100,
		// 					hsfRate: 200,
		// 					dueAmount: 2300,
		// 					clientId: "68db990a513b66617fead1d4",
		// 					employeeQpp: 111,
		// 					employeeQpip: 111,
		// 					federalTax: 111,
		// 					provincialTax: 111,
		// 					employerQpp: 111,
		// 					totalQpp: 111,
		// 					rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 					paymentDate: ["2025-10-15"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-11-15"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 2,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 2000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d03",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 3,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 3000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d04",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [],
		// 		},
		// 		{
		// 			id: 4,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 4000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d05",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					id: "1002-0",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 				{
		// 					id: "1002-1",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 			],
		// 		},
		// 	],
		// 	keyField: [
		// 		{
		// 			field: "id",
		// 			templateUrl: "/rq-remittance-report/details/id",
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "serialNumber",
		// 			headerName: "No.",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "paymentDate",
		// 			headerName: "End Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 1,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpp",
		// 			headerName: "Employee QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpp",
		// 			headerName: "Employer QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 3,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpp",
		// 			headerName: "Total QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 4,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpip",
		// 			headerName: "Employee QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 5,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpip",
		// 			headerName: "Employer QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 6,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpip",
		// 			headerName: "Total QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 7,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "federalTax",
		// 			headerName: "Federal Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 8,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "provincialTax",
		// 			headerName: "Provincial Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 9,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "hsfRate",
		// 			headerName: "HSF Contibution",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 10,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "csstAmount",
		// 			headerName: "CSST",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 11,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "dueAmount",
		// 			headerName: "Current Payment",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 12,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000)
		// );

		if (!remittanceFrequencyId) return null;

		if (remittanceFrequencyId && remittanceFrequencyId.value) {
			try {
				const response: AxiosResponse<ICRAReportListModel> =
					await http.get<ICRAReportListModel>(
						"/v1/cra-remittance-report/?client_id=" +
							clientId +
							"&remittance_frequency=" +
							remittanceFrequencyId.value +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							data.order_by +
							"&order_direction=" +
							data.order_direction +
							"&tax_year=" +
							taxYear +
							"&page=" +
							data.page +
							"&size=" +
							data.size,
					);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
	},

	getCRAAddRemoveHeaderColumns: async (
		// clientId: any,
		requestPayload: any,
	): Promise<ICRAReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ICRAReportListModel> =
				await http.put<ICRAReportListModel>(
					`/v1/cra-remittance-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);
			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getRQReport: async (
		remittanceFrequencyId: null | { label: string; value: string },
		viewByDate: number,
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
		navigateToLogout: (path: any) => void,
	): Promise<IRQReportListModel | IServerError | IResponse | null | any> => {
		// const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 12,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 1000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					csstAmount: 100,
		// 					hsfRate: 200,
		// 					dueAmount: 2300,
		// 					clientId: "68db990a513b66617fead1d4",
		// 					employeeQpp: 111,
		// 					employeeQpip: 111,
		// 					federalTax: 111,
		// 					provincialTax: 111,
		// 					employerQpp: 111,
		// 					totalQpp: 111,
		// 					rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 					paymentDate: ["2025-10-15"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-11-15"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 1,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 2000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d03",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 3,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 3000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d04",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [],
		// 		},
		// 		{
		// 			id: 4,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 4000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d05",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					id: "1002-0",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 				{
		// 					id: "1002-1",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 			],
		// 		},
		// 	],
		// 	keyField: [
		// 		{
		// 			field: "id",
		// 			templateUrl: "/rq-remittance-report/details/id",
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "serialNumber",
		// 			headerName: "No.",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "paymentDate",
		// 			headerName: "End Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 1,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpp",
		// 			headerName: "Employee QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpp",
		// 			headerName: "Employer QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 3,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpp",
		// 			headerName: "Total QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 4,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpip",
		// 			headerName: "Employee QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 5,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpip",
		// 			headerName: "Employer QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 6,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpip",
		// 			headerName: "Total QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 7,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "federalTax",
		// 			headerName: "Federal Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 8,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "provincialTax",
		// 			headerName: "Provincial Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 9,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "hsfRate",
		// 			headerName: "HSF Contibution",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 10,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "csstAmount",
		// 			headerName: "CSST",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 11,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "dueAmount",
		// 			headerName: "Current Payment",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 12,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000)
		// );
		if (!remittanceFrequencyId) return null;

		if (remittanceFrequencyId && remittanceFrequencyId.value) {
			try {
				const response: AxiosResponse<IRQReportListModel> =
					await http.get<IRQReportListModel>(
						"/v1/rq-remittance-report/?client_id=" +
							clientId +
							"&remittance_frequency=" +
							remittanceFrequencyId.value +
							"&search_query=" +
							data.search_query +
							"&order_by=" +
							data.order_by +
							"&order_direction=" +
							data.order_direction +
							"&tax_year=" +
							taxYear +
							"&page=" +
							data.page +
							"&size=" +
							data.size,
					);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
	},

	getRQAddRemoveHeaderColumns: async (
		// clientId: any,
		requestPayload: any,
	): Promise<ICRAReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ICRAReportListModel> =
				await http.put<ICRAReportListModel>(
					`/v1/rq-remittance-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);
			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTD1Report: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		employee: string,
		provincialFederal: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<ITD1ReportModel | IServerError | IResponse | null> => {
		if (!runGetListAPICall || !employee || !provincialFederal) return null;
		try {
			const response: AxiosResponse<ITD1ReportModel> =
				await http.get<ITD1ReportModel>(
					"/v1/td1-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						"&employee=" +
						employee +
						"&provincial_federal=" +
						provincialFederal +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTD1AddRemoveHeaderColumns: async (
		requestPayload: any,
	): Promise<ITD1ReportModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ITD1ReportModel> =
				await http.put<ITD1ReportModel>(
					`/v1/td1-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);
			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getT4Report: async (
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
	): Promise<IT4ReportListModel | IServerError | IResponse> => {
		const response: AxiosResponse<IT4ReportListModel> =
			await http.get<IT4ReportListModel>(
				"/v1/t4-report/?client_id=" +
					clientId +
					"&tax_year=" +
					taxYear +
					"&order_by=" +
					data.order_by +
					"&order_direction=" +
					data.order_direction +
					"&page=" +
					data.page +
					"&size=" +
					data.size,
			);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getT4AddRemoveHeaderColumns: async (
		requestPayload: any,
	): Promise<IT4ReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IT4ReportListModel> =
				await http.put<IT4ReportListModel>(
					`/v1/t4-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getRL1Report: async (
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
	): Promise<IRL1ReportListModel | IServerError | IResponse | any> => {
		// const fixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 1,
		// 	items: [
		// 		{
		// 			name: "DIL KHAN",
		// 			province: "Alberta",
		// 			clientId: "69304714892fdf04c186d228",
		// 			taxYear: 2025,
		// 			employeeId: "693049ef892fdf04c186d22e",
		// 			provinceId: "682dcd5bf647853debdc6b78",
		// 			slipType: "ORIGINAL",
		// 			slipStatus: "COMPLETED",
		// 			status: "Active",
		// 			other_information: {},
		// 			provinceOfEmployment: "Alberta",
		// 			poe: "AB",
		// 			payPeriod: "",
		// 			boxARevenusDEmploi: 5020,
		// 			boxBOtisationAuRRQ: 13,
		// 			boxBBOtisationAuRRQ: 16,
		// 			boxCCotaIAssuranceEmploi: 33,
		// 			boxDCotisationAUnRPA: 22,
		// 			boxEImpotDuQuebecRetenu: 99,
		// 			boxFCotisationSyndicale: 0,
		// 			boxGSalaireAdmissibleAuRRQ: 12,
		// 			boxHCotisationAuRQAP: 14,
		// 			boxISalaireAdmissibleAuRQAP: 2,
		// 			boxNDonsDeBienfaisance: 0,
		// 		},
		// 	],
		// 	keyField: {
		// 		field: "name",
		// 		templateUrl: "/rl1-reports/{id}",
		// 	},
		// 	headerColumns: [
		// 		{
		// 			field: "name",
		// 			headerName: "Name",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: true,
		// 			footer: "Total",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "slipStatus",
		// 			headerName: "Slip Status",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 1,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "poe",
		// 			headerName: "POE",
		// 			description: "Province Of Employment",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: false,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "slipType",
		// 			headerName: "Slip Type",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 3,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "payPeriod",
		// 			headerName: "Pay Period",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 4,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxARevenusDEmploi",
		// 			headerName: "Employment Income",
		// 			description: "A-Revenus d'emploi",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 5,
		// 			frozenColumn: false,
		// 			footer: "5020.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxBOtisationAuRRQ",
		// 			headerName: "QPP",
		// 			description: "b-Otisation au RRQ",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 6,
		// 			frozenColumn: false,
		// 			footer: "13.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxBBOtisationAuRRQ",
		// 			headerName: "2nd QPP",
		// 			description: "bb-Otisation au RRQ",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 7,
		// 			frozenColumn: false,
		// 			footer: "16.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxCCotaIAssuranceEmploi",
		// 			headerName: "EI",
		// 			description: "C-Cot.a-Iassurance emploi",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 8,
		// 			frozenColumn: false,
		// 			footer: "33.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxDCotisationAUnRPA",
		// 			headerName: "RPP",
		// 			description: "D-Cotisation a un RPA",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 9,
		// 			frozenColumn: false,
		// 			footer: "22.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxEImpotDuQuebecRetenu",
		// 			headerName: "Income Tax",
		// 			description: "E-impot du Quebec retenu",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 10,
		// 			frozenColumn: false,
		// 			footer: "99.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxFCotisationSyndicale",
		// 			headerName: "Union Dues",
		// 			description: "F-Cotisation syndicale",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 11,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxGSalaireAdmissibleAuRRQ",
		// 			headerName: "Pensionable Earnings",
		// 			description: "G-Salaire admissible au RRQ",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 12,
		// 			frozenColumn: false,
		// 			footer: "12.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxHCotisationAuRQAP",
		// 			headerName: "QPIP",
		// 			description: "H-Cotisation au RQAP",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 13,
		// 			frozenColumn: false,
		// 			footer: "14.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxISalaireAdmissibleAuRQAP",
		// 			headerName: "QPIP Insurable Earnings",
		// 			description: "I-Salaire admissible au RQAP",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 14,
		// 			frozenColumn: false,
		// 			footer: "2.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxJRegimePriveDassMaladie",
		// 			headerName: "Box J",
		// 			description: "J-Regime prive d'ass maladie",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 15,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxKVoyages",
		// 			headerName: "Box K",
		// 			description: "k-Voyages(region eloignee)",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 16,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxLAutresAvantages",
		// 			headerName: "Box L",
		// 			description: "L-Autres avantages",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 17,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxMCommissions",
		// 			headerName: "Commissions",
		// 			description: "M-Commissions",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 18,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxNDonsDeBienfaisance",
		// 			headerName: "Charitable donations",
		// 			description: "N-Dons de bienfaisance",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 19,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxOAutresRevenus",
		// 			headerName: "Other Income Except Box A",
		// 			description: "O-Autres revenus",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 20,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxPRegimeDassInterentreprises",
		// 			headerName: "Box P",
		// 			description: "P-Regime d'ass interentreprises",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 21,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxQSalairesDifferes",
		// 			headerName: "Box Q",
		// 			description: "Q-Salaires differes",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 22,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxRRevenuSitueDansUneReserve",
		// 			headerName: "Box R",
		// 			description: "R-Revenu situe dans une reserve",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 23,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxSPourboiresRecus",
		// 			headerName: "Box S",
		// 			description: "S-Pourboires recus",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 24,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxTPourboiresAttribues",
		// 			headerName: "Box T",
		// 			description: "T-pourboires attribues",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 25,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxURetraiteProgressive",
		// 			headerName: "Box U",
		// 			description: "U-Retraite progressive",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 26,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxVNourritureEtLogement",
		// 			headerName: "Meals and lodging",
		// 			description: "V-Nourriture et logement",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 27,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "boxWVehiculeAMoteur",
		// 			headerName: "Box W",
		// 			description: "W-Vehicule a moteur",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 28,
		// 			frozenColumn: false,
		// 			footer: "0.0",
		// 			minWidth: null,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// 	totalHeaderColumns: {
		// 		name: true,
		// 		slipStatus: true,
		// 		provinceOfEmployment: true,
		// 		slipType: true,
		// 		payPeriod: true,
		// 		pensionablePeriod: true,
		// 		aRevenusDEmploi: true,
		// 		bOtisationAuRRQ: true,
		// 		bbOtisationAuRRQ: true,
		// 		cCotaIAssuranceEmploi: true,
		// 		dCotisationAUnRPA: true,
		// 		eImpotDuQuebecRetenu: true,
		// 		fCotisationSyndicale: true,
		// 		gSalaireAdmissibleAuRRQ: true,
		// 		hCotisationAuRQAP: true,
		// 		iSalaireAdmissibleAuRQAP: true,
		// 		jRegimePriveDassMaladie: true,
		// 		kVoyages: true,
		// 		lAutresAvantages: true,
		// 		mCommissions: true,
		// 		nDonsDeBienfaisance: true,
		// 		oAutresRevenus: true,
		// 		pRegimeDassInterentreprises: true,
		// 		qSalairesDifferes: true,
		// 		rRevenuSitueDansUneReserve: true,
		// 		sPourboiresRecus: true,
		// 		tPourboiresAttribues: true,
		// 		uRetraiteProgressive: true,
		// 		vNourritureEtLogement: true,
		// 		wVehiculeAMoteur: true,
		// 		cppQppExempt: true,
		// 		eiExempt: true,
		// 		ppipExempt: true,
		// 		reducedEi: true,
		// 	},
		// };

		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(fixedResponse), 1000)
		// );
		try {
			const response: AxiosResponse<IRL1ReportListModel> =
				await http.get<IRL1ReportListModel>(
					"/v1/rl1-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},

	getRL1AddRemoveHeaderColumns: async (
		requestPayload: any,
	): Promise<IRL1ReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IRL1ReportListModel> =
				await http.put<IRL1ReportListModel>(
					`/v1/rl1-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getEDRReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		employee: string,
		type: string,
		endDate: string,
		payPeriod: string,
		edr: string,
		taxYear: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IEDRReportListModel | IServerError | IResponse | null> => {
		if (!runGetListAPICall || !employee || !type) return null;
		try {
			const response: AxiosResponse<IEDRReportListModel> =
				await http.get<IEDRReportListModel>(
					"/v1/edr-report/?client_id=" +
						clientId +
						"&employee=" +
						employee +
						"&type=" +
						type +
						(endDate ? "&end_date=" + endDate : "") +
						"&pay_period=" +
						payPeriod +
						(edr ? "&earning_type=" + edr : "") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&tax_year=" +
						taxYear +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
	getEDRDDL: async (
		clientId: string,
		tag: string,
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<any[]> = await http.get<any[]>(
			`/v1/${tag}/${
				tag === "earnings"
					? "earning"
					: tag === "deductions"
						? "deduction"
						: tag
			}-ddl?client_id=${clientId}`,
		);

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getEDRAddRemoveHeaderColumns: async (
		requestPayload: any,
	): Promise<IEDRReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IEDRReportListModel> =
				await http.put<IEDRReportListModel>(
					`/v1/edr-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);
			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getEHTOntarioReport: async (
		clientId: string,

		remittanceFrequencyId: null | { label: string; value: string },
		taxYear: number,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IEmployeeReportListModel | IServerError | IResponse | null> => {
		if (!remittanceFrequencyId) return null;

		if (remittanceFrequencyId && remittanceFrequencyId.value) {
			try {
				const response: AxiosResponse<IEmployeeReportListModel> =
					await http.get<IEmployeeReportListModel>(
						"/v1/eht-ontario-report/?client_id=" +
							clientId +
							"&remittance_frequency=" +
							remittanceFrequencyId.value +
							"&tax_year=" +
							taxYear +
							"&order_by=" +
							data.order_by +
							"&order_direction=" +
							data.order_direction +
							"&page=" +
							data.page +
							"&size=" +
							data.size +
							"&search_query=" +
							data.search_query,
					);

				if (response.status === 200) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		} else {
			return null;
		}
		// if (clientId) {
		//   try {
		//     const response: AxiosResponse<IEmployeeReportListModel> =
		//       await http.get<IEmployeeReportListModel>(
		//         "/v1/employees/report/?client_id=" +
		//           clientId +
		//           "&order_by=" +
		//           data.order_by +
		//           "&order_direction=" +
		//           data.order_direction +
		//           "&page=" +
		//           data.page +
		//           "&size=" +
		//           data.size +
		//           "&search_query=" +
		//           data.search_query
		//       );

		//     if (response.status === 200) {
		//       return response.data;
		//     } else if (response.status === 400) {
		//       return {
		//         status: false,
		//         message: "Bad Request.",
		//         error: true,
		//       };
		//     } else if (response.status === 500) {
		//       return {
		//         status: false,
		//         message: "Something went wrong.",
		//         error: true,
		//       };
		//     }
		//     return {
		//       status: false,
		//       message: "Something went wrong please try again later.",
		//     };
		//   }
		//   catch (error) {
		//     const axiosError = error as AxiosError;
		//     console.error("An error occurred:", axiosError);
		//     const errorMessage =
		//       axiosError.response && typeof axiosError.response.data === "string"
		//         ? axiosError.response.data
		//         : "Unknown error";
		//     if (axiosError && axiosError.status === 401) {
		//       navigateToLogout("/logout");
		//       return {
		//         status: false,
		//         message: "UnAuthrized",
		//       };
		//     } else {
		//       return {
		//         status: false,
		//         message: errorMessage,
		//       };
		//     }
		//   }
		// } else {
		//   return null;
		// }
	},

	getEHTOntarioAddRemoveHeaderColumns: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<any> = await http.put<any>(
				`/v1/eht-ontario-report-header-columns/?client_id=${requestPayload.clientId}`,
				requestPayload.columns,
			);
			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getVendorReport: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<IEmployeeReportListModel | IServerError | IResponse> => {
		//       const fixedResponse: any = {
		//     "page": 1,
		//     "size": 50,
		//     "total": 1,
		//     "items": [
		//         {
		//             "id": "e767c8ea-41e2-42d2-a991-6e3d0f1f3068",
		//             "firstName": "test t4a",
		//             "lastName": "Ali",
		//             "uniqueIdentifier": "123456789",
		//             "email": "zeeshan123@gmail.com",
		//             "createdDate": "2023-07-03",
		//             "businessName": null,
		//             "businessNumber": null,
		//             "status": "Active",
		//             "address": {
		//                 "id": "718ab770-70cc-4813-9276-790096a80278",
		//                 "isPrimary": true,
		//                 "appAddressTypeId": 1,
		//                 "addressLine1": "testing",
		//                 "addressLine2": null,
		//                 "city": "dfdf",
		//                 "postalCode": "A5d5d5",
		//                 "province": {
		//                     "id": 5,
		//                     "name": "NewfoundLand & Labrador",
		//                     "shortCode": "NL"
		//                 },
		//                 "country": {
		//                     "id": 1,
		//                     "name": "Canada",
		//                     "shortCode": "CAN"
		//                 }
		//             },
		//             "metaFields": {
		//                 "name_0": "INITIALS",
		//                 "value_0": "Z"
		//             },
		//             "bankAccounts": []
		//         }
		//     ],
		//     "keyField": {
		//         "field": "name",
		//         "templateUrl": "/employees-report/{id}"
		//     },
		//     "headerColumns": [
		//         {
		//             "field": "firstName",
		//             "headerName": "Name",
		//             "description": "Name",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 0
		//         },
		//         {
		//             "field": "status",
		//             "headerName": "Status",
		//             "description": "status",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 1
		//         },
		//         {
		//             "field": "uniqueIdentifier",
		//             "headerName": "Unique Identifier",
		//             "description": "unique Identifier",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 2
		//         },
		//         {
		//             "field": "email",
		//             "headerName": "Email",
		//             "description": "Email",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 3
		//         },
		//         {
		//             "field": "address.addressLine1",
		//             "headerName": "Address",
		//             "description": "Address",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 4
		//         },
		//         {
		//             "field": "address.city",
		//             "headerName": "City",
		//             "description": "City",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 5
		//         },
		//         {
		//             "field": "address.postalCode",
		//             "headerName": "Postal Code",
		//             "description": "postal Code",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 6
		//         },
		//         {
		//             "field": "address.province.name",
		//             "headerName": "Province",
		//             "description": "province",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 7
		//         },
		//         {
		//             "field": "metaFields.value_0",
		//             "headerName": "INITIALS",
		//             "description": "INITIALS",
		//             "flex": 1,
		//             "hide": false,
		//             "hideable": false,
		//             "sortable": true,
		//             "sortingOrder": "asc",
		//             "resizable": false,
		//             "type": "string",
		//             "align": "left",
		//             "headerAlign": "left",
		//             "hideSortIcons": false,
		//             "disableColumnMenu": true,
		//             "disableReorder": true,
		//             "disableExport": true,
		//             "maskable": false,
		//             "isFixed": true,
		//             "sequence": 8
		//         }
		//     ]
		// }
		//       return new Promise(resolve => setTimeout(() => resolve(fixedResponse), 1000));

		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/vendors-employee-report/vendors/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
		);
		// `/v1/vendors-employee-report/vendors/?client_id=${clientId}?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getT4ReportNew: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<IT4ReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IT4ReportListModel> =
				await http.get<IT4ReportListModel>(
					// `/reports/t4-reports?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);
					`/v1/t4-reports/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},
	getT4AReportNew: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<IT4AReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IT4ReportListModel> =
				await http.get<IT4ReportListModel>(
					// `/reports/t4-reports?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);
					`/v1/t4a-reports/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},
	getT5ReportNew: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<IT4ReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IT4ReportListModel> =
				await http.get<IT4ReportListModel>(
					// `/reports/t4-reports?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);
					`/v1/t5-reports/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},
	getT3ReportNew: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<IT4ReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IT4ReportListModel> =
				await http.get<IT4ReportListModel>(
					// `/reports/t4-reports?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);
					`/v1/t3-reports/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},
	getRL3ReportNew: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<any | IServerError | IResponse> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				// `/reports/t4-reports?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);
				`/v1/rl3-reports/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},
	getRL16ReportNew: async (
		clientId: string,
		taxYear: number,
		params: IGetListRequest,
	): Promise<any | IServerError | IResponse> => {
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				// `/reports/t4-reports?order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`);
				`/v1/rl16-reports/?client_id=${clientId}&tax_year=${taxYear}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			} else {
				return response.data;
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			return {
				status: false,
				message: axiosError.response
					? axiosError.response.data
					: "Unknown error",
			};
		}
	},
	getGenerralClient: async (
		params: IGetListRequest,
	): Promise<IRL1ReportListModel | IServerError | IResponse> => {
		// const fixedResponse: any = {
		//   page: 1,
		//   size: 5,
		//   total: 5,
		//   items: [
		//     {
		//       clientId: "46f82067-3fe4-4d7d-ab30-a94cd14e3cd6",
		//       clientName: "payment method",
		//       code: null,
		//       id: "64f6e1e32eaf39f36a4f31c8",
		//     },
		//     {
		//       clientId: "2c22539c-3588-4505-80cd-219873a962e2",
		//       clientName: "Zeeshan Test Client 00145",
		//       code: "Zee",
		//       id: "64f6e37f2eaf39f36a4f31ca",
		//     },
		//     {
		//       clientId: "27ae00b8-a44f-44ed-896e-9697c17ba842",
		//       clientName: "Client 02",
		//       code: "Cli",
		//       id: "64f5a67cad991882c56681d8",
		//     },
		//     {
		//       clientId: "96e2791e-c622-4153-baa2-dad976e5f6da",
		//       clientName: "xml imp",
		//       code: "xml",
		//       id: "64f5a62ead991882c56681b6",
		//     },
		//     {
		//       clientId: "05a83dc3-8912-4a47-a733-652fed1d56fc",
		//       clientName: "client 001",
		//       code: "cli",
		//       id: "64f5d750134d3d21a1bb9de3",
		//     },
		//   ],
		//   keyField: {
		//     field: "id",
		//     templateUrl: "/id",
		//   },
		//   headerColumns: [
		//     // {
		//     //     "field": "clientId",
		//     //     "headerName": "Id",
		//     //     "description": "client Id",
		//     //     "flex": 1,
		//     //     "hide": false,
		//     //     "hideable": false,
		//     //     "sortable": true,
		//     //     "sortingOrder": "asc",
		//     //     "resizable": false,
		//     //     "type": "string",
		//     //     "align": "left",
		//     //     "headerAlign": "left",
		//     //     "hideSortIcons": false,
		//     //     "disableColumnMenu": true,
		//     //     "disableReorder": true,
		//     //     "disableExport": true,
		//     //     "maskable": false,
		//     //     "isFixed": true,
		//     //     "sequence": 0,
		//     //     "frozenColumn": false,
		//     //     "footer": null
		//     // },
		//     {
		//       field: "clientName",
		//       headerName: "Client Name",
		//       description: "Client Name",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 1,
		//       frozenColumn: false,
		//       footer: null,
		//     },
		//     {
		//       field: "code",
		//       headerName: "Code",
		//       description: "Code",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "text",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 200,
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(fixedResponse), 1000)
		// );

		const response: AxiosResponse<IRL1ReportListModel> =
			await http.get<IRL1ReportListModel>(
				`/v1/general-clients/?search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
			);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	updateInvoice: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.put<any>(
			`/v1/billing-calculation/${requestPayload.refNo}/`,
			requestPayload,
		);

		if (response.status === 200) {
			return response.data;
		}
		if (response.status === 400) {
			return response.data;
		}
		if (response.status === 201) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	updateJournalCode: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.put<any>(
			`/v1/general-clients/`,
			requestPayload,
		);

		if (response.status === 200) {
			return response.data;
		}
		if (response.status === 201) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	generateInvoiceMail: async (
		clientId: string,
		refNo: string,
		email: string,
	): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.post<any>(
			`/v1/email-generate/invoice/?client_id=${clientId}&ref_no=${refNo}&email=${email}`,
		);

		if (response.status === 201) {
			return response;
		} else if (response.status === 400) {
			return response;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getAdminTransactionsReport: async (
		params: any,
	): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/tansaction-reports/?payment_status=${params.invoiceselected}&accountant_id=${params.accountantselected}&tax_year=${params.yearselected}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
		);
		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getClientAdjustmentReport: async (
		params: any,
	): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(
			`/v1/dashboard-api/client_adjustments/?accountant_id=${params.accountantId}&tax_year=${params.yearselected}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
		);
		if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getUserDDL: async (): Promise<any | IServerError | IResponse> => {
		const response: AxiosResponse<any> = await http.get<any>(`/user-ddl`);

		if (response.status === 200) {
			return response.data;
		} else if (response.status === 201) {
			return response.data;
		} else if (response.status === 400) {
			return response.data;
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},
	getInvoiceNumbersDDL: async (
		clientId: string,
		taxYear?: number,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
				IDropDownListResponse[]
			>(`/v1/transaction-log/${clientId}/by-client/`);
			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},
	getTransactionTypeDDL: async (
		clientId: string,
		taxYear?: number,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
				IDropDownListResponse[]
			>(
				`/v1/payroll-schedule/pay-frequency-ddl/?client_id=${clientId}&tax_year=${taxYear}`,
			);
			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},

	getPayrollReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		startDate: string | null,
		endDate: string | null,
		groupBy: number,
		paymentStatus: string,
		expenseCategory: string,
		paymentMethod: string,
		provinceOfEmployment: string,
		reportDate: number,
		payPeriod: string,
		payPeriodEndDate: string,
		department: string,
		team: string,
		employee: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<any | IServerError | IResponse | null> => {
		if (!runGetListAPICall) return null;
		// const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 12,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 1000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					csstAmount: 100,
		// 					hsfRate: 200,
		// 					dueAmount: 2300,
		// 					clientId: "68db990a513b66617fead1d4",
		// 					employeeQpp: 111,
		// 					employeeQpip: 111,
		// 					federalTax: 111,
		// 					provincialTax: 111,
		// 					employerQpp: 111,
		// 					totalQpp: 111,
		// 					rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 					paymentDate: ["2025-10-15"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-11-15"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 2,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 2000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d03",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 3,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 3000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d04",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [],
		// 		},
		// 		{
		// 			id: 4,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 4000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d05",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					id: "1002-0",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 				{
		// 					id: "1002-1",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 			],
		// 		},
		// 	],
		// 	keyField: [
		// 		{
		// 			field: "id",
		// 			templateUrl: "/rq-remittance-report/details/id",
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "serialNumber",
		// 			headerName: "No.",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "paymentDate",
		// 			headerName: "End Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 1,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpp",
		// 			headerName: "Employee QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpp",
		// 			headerName: "Employer QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 3,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpp",
		// 			headerName: "Total QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 4,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpip",
		// 			headerName: "Employee QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 5,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpip",
		// 			headerName: "Employer QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 6,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpip",
		// 			headerName: "Total QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 7,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "federalTax",
		// 			headerName: "Federal Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 8,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "provincialTax",
		// 			headerName: "Provincial Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 9,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "hsfRate",
		// 			headerName: "HSF Contibution",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 10,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "csstAmount",
		// 			headerName: "CSST",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 11,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "dueAmount",
		// 			headerName: "Current Payment",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 12,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000),
		// );
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				"/v1/payroll-report/?client_id=" +
					clientId +
					"&tax_year=" +
					taxYear +
					(startDate ? "&date_range_start_date=" + startDate : "") +
					(endDate ? "&date_range_end_date=" + endDate : "") +
					"&group_by=" +
					groupBy +
					"&payment_status=" +
					paymentStatus +
					"&expense_category=" +
					expenseCategory +
					"&payment_method=" +
					paymentMethod +
					"&province_of_employment=" +
					provinceOfEmployment +
					"&report_date=" +
					reportDate +
					"&pay_period=" +
					payPeriod +
					"&pay_period_end_date=" +
					payPeriodEndDate +
					"&department=" +
					department +
					"&team=" +
					team +
					"&employee=" +
					employee +
					"&search_query=" +
					data.search_query +
					"&order_by=" +
					data.order_by +
					"&order_direction=" +
					data.order_direction +
					"&page=" +
					data.page +
					"&size=" +
					data.size,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getPayrollReportAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<ISalaryProfileReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ISalaryProfileReportListModel> =
				await http.put<ISalaryProfileReportListModel>(
					`/v1/payroll-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getEndDateDDL: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		try {
			const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
				IDropDownListResponse[]
			>(`/v1/end-Date/?client_id=${clientId}`);
			if (response.status === 200) {
				return response.data;
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch {}
	},

	getStubReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		employeeId: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<any | IServerError | IResponse | null> => {
		if (!runGetListAPICall || !employeeId) return null;
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				"/v1/payroll-stub-report/?client_id=" +
					clientId +
					"&employee_id=" +
					employeeId +
					// "&start_date=" +
					// startDate +
					// "&end_date=" +
					// endDate +
					(startDate ? "&start_date=" + startDate : "") +
					(endDate ? "&end_date=" + endDate : "") +
					"&order_by=" +
					data.order_by +
					"&order_direction=" +
					data.order_direction +
					"&page=" +
					data.page +
					"&size=" +
					data.size,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getDownloadStubListData: async (
		// requestPayload:any,
		employeeId: string,
		clientId: string,
		startDate: String | null,
		endDate: string | null,
		payPeriodEndDateList: any,
	): Promise<any | IServerError | IResponse | any> => {
		if (!payPeriodEndDateList) return null;
		try {
			// 		 const requestPayload = [
			//   startDate,  // must be YYYY-MM-DD
			//   endDate
			// ];
			const url =
				"/v1/payroll-stub-printing/within-period?employee_id=" +
				employeeId +
				"&client_id=" +
				clientId +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "");

			const response = await http.post(url, payPeriodEndDateList, {
				responseType: "arraybuffer",
			});
			// const response = await http.post(url)
			if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			return {
				status: false,
				message: errorMessage,
			};
		}
	},

	getPaydayAdvanceReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		employeeId: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IEmployeeReportListModel | IServerError | IResponse | null> => {
		if (!runGetListAPICall || !employeeId) return null;
		try {
			const response: AxiosResponse<IEmployeeReportListModel> =
				await http.get<IEmployeeReportListModel>(
					"/v1/payday-advance-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						"&employee=" +
						employeeId +
						(startDate ? "&start_date=" + startDate : "") +
						(endDate ? "&start_date=" + endDate : "") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	submitPaydayAdvanceReportAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<IYearToDateReportModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IYearToDateReportModel> =
				await http.put<IYearToDateReportModel>(
					`/v1/payday-advance-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getYearToDateReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		employee: string,
		employeeType: string,
		payPeriod: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IYearToDateReportModel | IServerError | IResponse | null> => {
		// const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 2,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			employeeId: "1001",
		// 			name: "AA",
		// 			period: "2026-03-01",
		// 			province: "Alberta",
		// 			year: 2026,
		// 			regGross: 2,
		// 			overTime15: 40,
		// 			overTime20: 60,
		// 			vacationPay: 777,
		// 			holidayPay: null,
		// 			nonPeriodic: null,
		// 		},
		// 		{
		// 			id: 2,
		// 			employeeId: "1001",
		// 			name: "AA",
		// 			period: "2026-03-01",
		// 			province: "Alberta",
		// 			year: 2026,
		// 			regGross: 2,
		// 			overTime15: 40,
		// 			overTime20: 60,
		// 			vacationPay: 777,
		// 			holidayPay: null,
		// 			nonPeriodic: null,
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "employeeId",
		// 			headerName: "Emp ID",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "name",
		// 			headerName: "Name",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "period",
		// 			headerName: "Period",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "province",
		// 			headerName: "Province",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "year",
		// 			headerName: "Year",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "regGross",
		// 			headerName: "Reg. Gross",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "overTime15",
		// 			headerName: "over Time 1.5",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "overTime20",
		// 			headerName: "over Time 2.0",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "vacationPay",
		// 			headerName: "Vacation Pay",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "holidayPay",
		// 			headerName: "Holiday Pay",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "nonPeriodic",
		// 			headerName: "Non Periodic",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000),
		// );

		if (!runGetListAPICall || !taxYear) return null;
		try {
			const response: AxiosResponse<IYearToDateReportModel> =
				await http.get<IYearToDateReportModel>(
					"/v1/year-to-date-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						// ( taxYear ? "&tax_year" + taxYear : "") +
						"&employee=" +
						employee +
						"&employee_type=" +
						employeeType +
						"&pay_period=" +
						payPeriod +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getYearToDateAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<IYearToDateReportModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IYearToDateReportModel> =
				await http.put<IYearToDateReportModel>(
					`/v1/year-to-date-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getPayrollAdjustmentReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		employeeName: string,
		payPeriod: string,
		periodEndDate: string,
		team: string,
		department: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IPayrollAdjustmentReportListModel | IServerError | IResponse | null
	> => {
		// const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 2,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			name: "Emp One",
		// 			payPeriodDate: "Jan 15 2026",
		// 			postDate: "-",
		// 			hours: "100.00",
		// 			regGross: "2000",
		// 			ot: "00.00",
		// 			holidayPay: "00.00",
		// 			vacPay: "00.00",
		// 			nonPeriodic: "00.00",
		// 			comm: "00.00",
		// 			totalGross: "2080.00",
		// 			cppAndQpp: "115.08",
		// 			ei: "33.90",
		// 			qpp: "00.00",
		// 			fedTax: "165.62",
		// 		},
		// 		{
		// 			id: 2,
		// 			name: "Emp One",
		// 			payPeriodDate: "Jan 15 2026",
		// 			postDate: "March 30 2026",
		// 			hours: "100.00",
		// 			regGross: "2000",
		// 			ot: "00.00",
		// 			holidayPay: "00.00",
		// 			vacPay: "00.00",
		// 			nonPeriodic: "00.00",
		// 			comm: "00.00",
		// 			totalGross: "2080.00",
		// 			cppAndQpp: "115.08",
		// 			ei: "33.90",
		// 			qpp: "00.00",
		// 			fedTax: "165.62",
		// 		},
		// 		{
		// 			id: 3,
		// 			name: "Emp One",
		// 			payPeriodDate: "Jan 15 2026",
		// 			postDate: "-",
		// 			hours: "100.00",
		// 			regGross: "2000",
		// 			ot: "00.00",
		// 			holidayPay: "00.00",
		// 			vacPay: "00.00",
		// 			nonPeriodic: "00.00",
		// 			comm: "00.00",
		// 			totalGross: "2080.00",
		// 			cppAndQpp: "115.08",
		// 			ei: "33.90",
		// 			qpp: "00.00",
		// 			fedTax: "165.62",
		// 		},
		// 			{
		// 			id: 4,
		// 			name: "Emp One",
		// 			payPeriodDate: "Jan 15 2026",
		// 			postDate: "-",
		// 			hours: "100.00",
		// 			regGross: "2000",
		// 			ot: "00.00",
		// 			holidayPay: "00.00",
		// 			vacPay: "00.00",
		// 			nonPeriodic: "00.00",
		// 			comm: "00.00",
		// 			totalGross: "2080.00",
		// 			cppAndQpp: "115.08",
		// 			ei: "33.90",
		// 			qpip: "00.00",
		// 			fedTax: "165.62",
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "name",
		// 			headerName: "Name",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "payPeriodDate",
		// 			headerName: "Pay Period Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "postDate",
		// 			headerName: "Post Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "hours",
		// 			headerName: "Hours",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "regGross",
		// 			headerName: "Reg.Gross",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "ot",
		// 			headerName: "OT",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "holidayPay",
		// 			headerName: "Holiday Pay",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "vacPay",
		// 			headerName: "Vac.Pay",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "nonPeriodic",
		// 			headerName: "Non Periodic",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "comm",
		// 			headerName: "Comm",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalGross",
		// 			headerName: "Total Gross",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "cppAndQpp",
		// 			headerName: "CPP/QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "ei",
		// 			headerName: "EI",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "qpip",
		// 			headerName: "QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "fedTax",
		// 			headerName: "Fed.Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000),
		// );
		if (!runGetListAPICall || !payPeriod) return null;
		try {
			const response: AxiosResponse<IPayrollAdjustmentReportListModel> =
				await http.get<IPayrollAdjustmentReportListModel>(
					"/v1/payroll-adjustment-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						// "&employee_name=" +
						// employeeName +
						(employeeName ? "&employee_name=" + employeeName : "") +
						"&pay_period=" +
						payPeriod +
						"&period_end_date=" +
						periodEndDate +
						"&team=" +
						team +
						"&department=" +
						department +
						(startDate ? "&start_date=" + startDate : "") +
						(endDate ? "&end_date=" + endDate : "") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getPayrollAdjustmentAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<ISalaryProfileReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ISalaryProfileReportListModel> =
				await http.put<ISalaryProfileReportListModel>(
					`/v1/payroll-adjustment-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getROEReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		employee: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IROEReportModel | IServerError | IResponse | null> => {
		// const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 2,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			employeeId: "1001",
		// 			name: "AA",
		// 			period: "2026-03-01",
		// 			province: "Alberta",
		// 			year: 2026,
		// 			regGross: 2,
		// 			overTime15: 40,
		// 			overTime20: 60,
		// 			vacationPay: 777,
		// 			holidayPay: null,
		// 			nonPeriodic: null,
		// 		},
		// 		{
		// 			id: 2,
		// 			employeeId: "1001",
		// 			name: "AA",
		// 			period: "2026-03-01",
		// 			province: "Alberta",
		// 			year: 2026,
		// 			regGross: 2,
		// 			overTime15: 40,
		// 			overTime20: 60,
		// 			vacationPay: 777,
		// 			holidayPay: null,
		// 			nonPeriodic: null,
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "employeeId",
		// 			headerName: "Emp ID",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "name",
		// 			headerName: "Name",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "period",
		// 			headerName: "Period",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "province",
		// 			headerName: "Province",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "year",
		// 			headerName: "Year",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "regGross",
		// 			headerName: "Reg. Gross",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "overTime15",
		// 			headerName: "over Time 1.5",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "overTime20",
		// 			headerName: "over Time 2.0",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "vacationPay",
		// 			headerName: "Vacation Pay",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "holidayPay",
		// 			headerName: "Holiday Pay",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "nonPeriodic",
		// 			headerName: "Non Periodic",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "right",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000),
		// );
		if (!runGetListAPICall || !employee) return null;
		try {
			const response: AxiosResponse<IROEReportModel> =
				await http.get<IROEReportModel>(
					"/v1/roe-report/?client_id=" +
						clientId +
						"&employee=" +
						employee +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size +
						"&search_query=" +
						data.search_query,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getROEAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<IROEReportModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IROEReportModel> =
				await http.put<IROEReportModel>(
					`/v1/roe-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	// ROE Report DDL With Date
	getROEDDLWithDate: async (
		clientId: string,
	): Promise<any | IServerError | IResponse | null> => {
		const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
			IDropDownListResponse[]
		>(`/v1/roe-report/roe-ddl-with-date?client_id=${clientId}`);

		if (response.status === 200) {
			return response.data;
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
	},

	getWSIBReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		groupBy: string,
		department: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IWSIBReportListModel | IServerError | IResponse | null | any> => {
		// 	const RQFixedResponse: any = {
		// 	page: 1,
		// 	size: 50,
		// 	total: 12,
		// 	items: [
		// 		{
		// 			id: 1,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 1000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					csstAmount: 100,
		// 					hsfRate: 200,
		// 					dueAmount: 2300,
		// 					clientId: "68db990a513b66617fead1d4",
		// 					employeeQpp: 111,
		// 					employeeQpip: 111,
		// 					federalTax: 111,
		// 					provincialTax: 111,
		// 					employerQpp: 111,
		// 					totalQpp: 111,
		// 					rqRemittanceId: "690c9922e7bc42e97b457d02",
		// 					paymentDate: ["2025-10-15"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-11-15"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 2,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 2000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d03",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 				{
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-13"],
		// 				},
		// 			],
		// 		},
		// 		{
		// 			id: 3,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 3000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d04",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [],
		// 		},
		// 		{
		// 			id: 4,
		// 			csstAmount: null,
		// 			hsfRate: null,
		// 			dueAmount: 4000,
		// 			clientId: "68db990a513b66617fead1d4",
		// 			employeeQpp: 564,
		// 			employeeQpip: 456,
		// 			federalTax: 1344,
		// 			provincialTax: 122,
		// 			employerQpp: 564,
		// 			totalQpp: 1128,
		// 			rqRemittanceId: "690c9922e7bc42e97b457d05",
		// 			paymentDate: ["2025-10-15"],
		// 			orders: [
		// 				{
		// 					id: "1002-0",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 				{
		// 					id: "1002-1",
		// 					employeeQpp: 564,
		// 					employeeQpip: 456,
		// 					federalTax: 1344,
		// 					provincialTax: 122,
		// 					employerQpp: 564,
		// 					paymentDate: ["2025-10-14"],
		// 				},
		// 			],
		// 		},
		// 	],
		// 	keyField: [
		// 		{
		// 			field: "id",
		// 			templateUrl: "/rq-remittance-report/details/id",
		// 		},
		// 	],
		// 	headerColumns: [
		// 		{
		// 			field: "serialNumber",
		// 			headerName: "No.",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 0,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 50,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "paymentDate",
		// 			headerName: "End Date",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 1,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpp",
		// 			headerName: "Employee QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 2,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpp",
		// 			headerName: "Employer QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 3,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpp",
		// 			headerName: "Total QPP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 4,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employeeQpip",
		// 			headerName: "Employee QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 5,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "employerQpip",
		// 			headerName: "Employer QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 6,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "totalQpip",
		// 			headerName: "Total QPIP",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 7,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "federalTax",
		// 			headerName: "Federal Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 8,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "provincialTax",
		// 			headerName: "Provincial Tax",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 9,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "hsfRate",
		// 			headerName: "HSF Contibution",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 10,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "csstAmount",
		// 			headerName: "CSST",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 11,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 		{
		// 			field: "dueAmount",
		// 			headerName: "Current Payment",
		// 			description: "",
		// 			flex: 1,
		// 			hide: false,
		// 			hideable: false,
		// 			sortable: true,
		// 			sortingOrder: "asc",
		// 			resizable: false,
		// 			type: "string",
		// 			align: "left",
		// 			headerAlign: "left",
		// 			hideSortIcons: false,
		// 			disableColumnMenu: true,
		// 			disableReorder: true,
		// 			disableExport: true,
		// 			maskable: false,
		// 			isFixed: true,
		// 			isEditable: true,
		// 			sequence: 12,
		// 			frozenColumn: false,
		// 			footer: null,
		// 			minWidth: 120,
		// 			maxWidth: null,
		// 			fieldName: null,
		// 			edr: "edr",
		// 		},
		// 	],
		// };
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(RQFixedResponse), 1000)
		// );

		if (!runGetListAPICall || !taxYear) return null;
		try {
			const response: AxiosResponse<ICRAReportListModel> =
				await http.get<ICRAReportListModel>(
					"/v1/wsib-ontario-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						"&group_by=" +
						groupBy +
						"&department=" +
						department +
						(startDate ? "&start_date=" + startDate : "") +
						(endDate ? "&end_date=" + endDate : "") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getWSIBAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<IROEReportModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<IROEReportModel> =
				await http.put<IROEReportModel>(
					`/v1/wsib-ontario-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTimeSheetReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		taxYear: number,
		employee: string,
		hourType: string,
		startDate: string | null,
		endDate: string | null,
		payPeriod: string,
		// classes: string,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<ITimeSheetReportListModel | IServerError | IResponse | null> => {
		if (!runGetListAPICall || !employee) return null;
		try {
			const response: AxiosResponse<ITimeSheetReportListModel> =
				await http.get<ITimeSheetReportListModel>(
					"/v1/time-sheet-report/?client_id=" +
						clientId +
						"&tax_year=" +
						taxYear +
						(startDate ? "&start_date=" + startDate : "") +
						(endDate ? "&end_date=" + endDate : "") +
						"&employee=" +
						employee +
						"&hour_Type=" +
						hourType +
						"&pay_period=" +
						payPeriod +
						// "&classes=" +
						// classes +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getTimeSheetAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<ITimeSheetReportListModel | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<ITimeSheetReportListModel> =
				await http.put<ITimeSheetReportListModel>(
					`/v1/time-sheet-report-header-columns/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getStatutoryHolidayReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		provinceId: string,
		holidayDate: string,
		employeeId: string,
		payPeriodEndDate: string,
		payPeriod: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IStatutoryHolidayReportListModel | IServerError | IResponse | null
	> => {
		// const StatutoryHolidayFixed: any = {
		//   page: 1,
		//   size: 50,
		//   total: 5,
		//   items: [
		//     {
		//       id: 3,
		//       customId: "TAT-007",
		//       province: "ALBERTA",
		//       name: "John Trottier",
		//       holiday: "New Year's Holiday",
		//       ppEndDate: "Jan 14 2026",
		//       hours: "0.00",
		//       hoursAmount: "0.00",
		//       holidayPay: "266.00",
		//       dueAmount: "266.00",
		//       openBalance: "1.2",
		//       paidAmount: "0.00",
		//     },
		//     {
		//       id: 5,
		//       customId: "TAT-011",
		//       province: "MANITOBA",
		//       name: "Ainslie White",
		//       holiday: "New Year's Holiday",
		//       ppEndDate: "Jan 14 2026",
		//       hours: "0.00",
		//       hoursAmount: "0.00",
		//       holidayPay: "384.00",
		//       dueAmount: "384.00",
		//       openBalance: null,
		//       paidAmount: "0.00",
		//     },
		//     {
		//       id: 6,
		//       customId: "TAT-002",
		//       province: "ALBERTA",
		//       name: "Amber Misner",
		//       holiday: "New Year's Holiday",
		//       ppEndDate: "Jan 14 2026",
		//       hours: "0.00",
		//       hoursAmount: "0.00",
		//       holidayPay: "218.40",
		//       dueAmount: "218.40",
		//       openBalance: null,
		//       paidAmount: "0.00",
		//     },
		//     {
		//       id: 9,
		//       customId: "TAT-005",
		//       province: "ALBERTA",
		//       name: "Lise Trottier-Campbell",
		//       holiday: "New Year's Holiday",
		//       ppEndDate: "Jan 14 2026",
		//       hours: "0.00",
		//       hoursAmount: "0.00",
		//       holidayPay: "267.40",
		//       dueAmount: "267.40",
		//       openBalance: null,
		//       paidAmount: "0.00",
		//     },
		//     {
		//       id: 13,
		//       customId: "",
		//       province: "ALBERTA",
		//       name: "Roni Riley",
		//       holiday: "New Year's Holiday",
		//       ppEndDate: "Jan 14 2026",
		//       hours: "0.00",
		//       hoursAmount: "0.00",
		//       holidayPay: "281.46",
		//       dueAmount: "281.46",
		//       openBalance: null,
		//       paidAmount: "0.00",
		//     },
		//   ],
		//   headerColumns: [
		//     {
		//       field: "id",
		//       headerName: "ID",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 0,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "customId",
		//       headerName: "Custom ID",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 1,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "province",
		//       headerName: "Province",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 2,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "name",
		//       headerName: "Name",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 3,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holiday",
		//       headerName: "Holiday",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 4,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "ppEndDate",
		//       headerName: "P.P. End Date",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "string",
		//       align: "left",
		//       headerAlign: "left",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 5,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "hours",
		//       headerName: "Hours",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "right",
		//       headerAlign: "right",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 6,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "hoursAmount",
		//       headerName: "Hours Amount",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "right",
		//       headerAlign: "right",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 7,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "holidayPay",
		//       headerName: "Holiday Pay",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "right",
		//       headerAlign: "right",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 8,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//     {
		//       field: "dueAmount",
		//       headerName: "Due Amount",
		//       description: "",
		//       flex: 1,
		//       hide: false,
		//       hideable: false,
		//       sortable: true,
		//       sortingOrder: "asc",
		//       resizable: false,
		//       type: "number",
		//       align: "right",
		//       headerAlign: "right",
		//       hideSortIcons: false,
		//       disableColumnMenu: true,
		//       disableReorder: true,
		//       disableExport: true,
		//       maskable: false,
		//       isFixed: true,
		//       isEditable: false,
		//       sequence: 9,
		//       frozenColumn: false,
		//       footer: null,
		//       minWidth: 50,
		//       maxWidth: null,
		//       fieldName: null,
		//       edr: "edr",
		//     },
		//   ],
		// };
		// return new Promise((resolve) =>
		//   setTimeout(() => resolve(StatutoryHolidayFixed), 1000),
		// );
		if (!runGetListAPICall) return null;
		if (!provinceId) return null;
		if (!employeeId) return null;
		try {
			const response: AxiosResponse<IPayrollAdjustmentReportListModel> =
				await http.get<IPayrollAdjustmentReportListModel>(
					"/v1/holiday-pay-report/report/?client_id=" +
						clientId +
						"&province_id=" +
						provinceId +
						"&holiday_date=" +
						holidayDate +
						"&employee_id=" +
						employeeId +
						"&pay_period_end_date=" +
						payPeriodEndDate +
						"&pay_period=" +
						payPeriod +
						(startDate ? "&start_date=" + startDate : "") +
						(endDate ? "&end_date=" + endDate : "") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getStatutoryHolidayAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<
		IStatutoryHolidayReportListModel | IServerError | IResponse | any
	> => {
		try {
			const response: AxiosResponse<IStatutoryHolidayReportListModel> =
				await http.put<IStatutoryHolidayReportListModel>(
					`/v1/holiday-pay-report/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getVacationPayReport: async (
		runGetListAPICall: boolean,
		clientId: string,
		emplpyeeId: string,
		holidayDate: string,
		employeeId: string,
		payPeriodEndDate: string,
		payPeriod: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<
		IVacationPayReportListModel | IServerError | IResponse | null
	> => {
		if (!runGetListAPICall) return null;
		try {
			const response: AxiosResponse<IVacationPayReportListModel> =
				await http.get<IVacationPayReportListModel>(
					"/v1/vacation-pay-report/report/?client_id=" +
						clientId +
						"&employeeId=" +
						emplpyeeId +
						"&open_balance=" +
						holidayDate +
						"&employee_id=" +
						employeeId +
						"&pay_period_end_date=" +
						payPeriodEndDate +
						"&pay_period=" +
						payPeriod +
						(startDate ? "&start_date=" + startDate : "") +
						(endDate ? "&end_date=" + endDate : "") +
						"&search_query=" +
						data.search_query +
						"&order_by=" +
						data.order_by +
						"&order_direction=" +
						data.order_direction +
						"&page=" +
						data.page +
						"&size=" +
						data.size,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getVacationPayAddRemoveHeaderColumns: async (
		// clientId: string,
		requestPayload: any,
	): // requestPayload: any
	Promise<
		IVacationPayReportListModel | IServerError | IResponse | any
	> => {
		try {
			const response: AxiosResponse<IVacationPayReportListModel> =
				await http.put<IVacationPayReportListModel>(
					`/v1/vacation-pay-report/?client_id=${requestPayload.clientId}`,
					requestPayload.columns,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 422) {
				return {
					status: false,
					message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	/////////////// Printing Apis //////////////////

	// Employee Report Export

	exportEmployeeReport: async (
		event: string,
		clientId: string,
		payFrequency: string | number,
		employeeStatus: string | number,
		payMethod: string | number,
		provinceOfEmployment: string,
		params: IGetListRequest,
		navigateToLogout: (path: string) => void,
	): Promise<IEmployeeReportListModel | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `/v1/employees-report-printing/pdf?client_id=${clientId}&pay_frequency=${payFrequency}&employee_status=${employeeStatus}&pay_method=${payMethod}&province_of_employment=${provinceOfEmployment}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/employees-report-printing/csv?client_id=${clientId}&pay_frequency=${payFrequency}&employee_status=${employeeStatus}&pay_method=${payMethod}&province_of_employment=${provinceOfEmployment}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `/v1/employees-report-printing/xlsx?client_id=${clientId}&pay_frequency=${payFrequency}&employee_status=${employeeStatus}&pay_method=${payMethod}&province_of_employment=${provinceOfEmployment}&search_query=${params.search_query}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// TD1 Report Export //

	exportTD1Report: async (
		event: string,
		clientId: string,
		taxYear: number,
		employee: string,
		provincialFederal: string,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `/v1/td1-report-printing/pdf?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&provincial_federal=${provincialFederal}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/td1-report-printing/csv?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&provincial_federal=${provincialFederal}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `/v1/td1-report-printing/xlsx?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&provincial_federal=${provincialFederal}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// salary Profile Report Export //

	exportSalaryProfileReport: async (
		event: string,
		clientId: string,
		employeeStatus: string | number,
		employeeId: string,
		startDate: string | null,
		endDate: string | null,
		dateRange: boolean,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/salary-profile-report-printing/pdf?client_id=${clientId}&employee_status=${employeeStatus}&employee_id=${employeeId}` +
				(dateRange && startDate ? "&start_date=" + startDate : "") +
				(dateRange && endDate ? "&end_date=" + endDate : "") +
				"&date_range=" +
				(dateRange ? "true" : "false") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/salary-profile-report-printing/csv?client_id=${clientId}&employee_status=${employeeStatus}&employee_id=${employeeId}` +
					(dateRange && startDate ? "&start_date=" + startDate : "") +
					(dateRange && endDate ? "&end_date=" + endDate : "") +
					"&date_range=" +
					(dateRange ? "true" : "false") +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/salary-profile-report-printing/xlsx?client_id=${clientId}&employee_status=${employeeStatus}&employee_id=${employeeId}` +
				(dateRange && startDate ? "&start_date=" + startDate : "") +
				(dateRange && endDate ? "&end_date=" + endDate : "") +
				"&date_range=" +
				(dateRange ? "true" : "false") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// EDR Report Export //

	exportEDRReport: async (
		event: string,
		clientId: string,
		taxYear: number,
		employee: string,
		type: string,
		endDate: string,
		payPeriod: string,
		earningType: string,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `/v1/edr-report-printing/pdf?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&type=${type}${
				type && type !== "all" ? `&earning_type=${earningType}` : ""
			}
            &pay_period=${payPeriod}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/edr-report-printing/csv?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&type=${type}${
					type && type !== "all" ? `&earning_type=${earningType}` : ""
				}&pay_period=${payPeriod}${
					payPeriod && payPeriod !== "all" && endDate
						? `&end_date=${endDate}`
						: ""
				}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `/v1/edr-report-printing/xlsx?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&type=${type}${
				type && type !== "all" ? `&earning_type=${earningType}` : ""
			}&pay_period=${payPeriod}${
				payPeriod && payPeriod !== "all" && endDate
					? `&end_date=${endDate}`
					: ""
			}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// CRA Report Export //

	exportCRAReport: async (
		event: string,
		clientId: string,
		remittanceFrequency: string,
		taxYear: number,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `/v1/cra-report-printing/pdf?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/cra-report-printing/csv?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `/v1/cra-report-printing/xlsx?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// RQ Report Export //

	exportRQReport: async (
		event: string,
		clientId: string,
		remittanceFrequency: string,
		taxYear: number,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `/v1/rq-report-printing/pdf?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/rq-report-printing/csv?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `/v1/rq-report-printing/xlsx?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// T4 Report Export //
	exportT4Report: async (
		event: string,
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `/v1/t4-report-printing/pdf?client_id=${clientId}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/t4-report-printing/csv?client_id=${clientId}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `/v1/t4-report-printing/xlsx?client_id=${clientId}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// Rl1 Report Export //

	exportRL1Report: async (
		event: string,
		clientId: string,
		taxYear: number,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url = `v1/rl1-report-printing/pdf?client_id=${clientId}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`v1/rl1-report-printing/csv?client_id=${clientId}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url = `v1/rl1-report-printing/xlsx?client_id=${clientId}&tax_year=${taxYear}&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// payday advance Report Export //

	exportPaydayAdvanceReport: async (
		event: string,
		clientId: string,
		taxYear: number,
		employee: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/payday-advance-report-printing/pdf?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/payday-advance-report-printing/csv?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}` +
					(startDate ? "&start_date=" + startDate : "") +
					(endDate ? "&end_date=" + endDate : "") +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/payday-advance-report-printing/xlsx?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// EHT Ontario Export

	exportEHTOntarioReport: async (
		event: string,
		clientId: string,
		remittanceFrequency: string | number,
		taxYear: number,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/eht-ontario-report/pdf?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/eht-ontario-report/csv?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}` +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/eht-ontario-report/xlsx?client_id=${clientId}&remittance_frequency=${remittanceFrequency}&tax_year=${taxYear}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// Year To Date Export
	exportYearToDateReport: async (
		event: string,
		clientId: string,
		taxYear: number,
		employee: string,
		employeeType: string,
		payPeriod: string,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/year-to-date-report/pdf?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&employee_type=${employeeType}&pay_period=${payPeriod}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/year-to-date-report/csv?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&employee_type=${employeeType}&pay_period=${payPeriod}` +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/year-to-date-report/xlsx?client_id=${clientId}&tax_year=${taxYear}&employee=${employee}&employee_type=${employeeType}&pay_period=${payPeriod}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// ROE Earnings Export
	exportROEEarningsReport: async (
		event: string,
		clientId: string,
		employee: string,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/roe-report/earnings-pdf?client_id=${clientId}&employee=${employee}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/roe-report/earnings-csv?client_id=${clientId}&employee=${employee}` +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/roe-report/earnings-xlsx?client_id=${clientId}&employee=${employee}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// ROE Hours Export
	exportROEHoursReport: async (
		event: string,
		clientId: string,
		employee: string,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/roe-report/hours-pdf?client_id=${clientId}&employee=${employee}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/roe-report/hours-csv?client_id=${clientId}&employee=${employee}` +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/roe-report/hours-xlsx?client_id=${clientId}&employee=${employee}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// Payroll Report Export
	exportPayrollReport: async (
		event: string,
		clientId: string,
		taxYear: number,
		dateRangeStartDate: string | null,
		dateRangeEndDate: string | null,
		groupBy: number,
		paymentStatus: string,
		expenseCategory: string,
		paymentMethod: string,
		provinceOfEmployment: string,
		reportDate: number,
		payPeriod: string,
		payPeriodEndDate: string,
		department: string,
		team: string,
		employee: string,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/payroll-report/pdf?client_id=${clientId}&tax_year=${taxYear}` +
				(dateRangeStartDate
					? "&date_range_start_date=" + dateRangeStartDate
					: "") +
				(dateRangeEndDate ? "&date_range_end_date=" + dateRangeEndDate : "") +
				`&group_by=${groupBy}&payment_status=${paymentStatus}&expense_category=${expenseCategory}&payment_method=${paymentMethod}&province_of_employment=${provinceOfEmployment}&report_date=${reportDate}&pay_period=${payPeriod}&pay_period_end_date=${payPeriodEndDate}&department=${department}&team=${team}&employee=${employee}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/payroll-report/csv?client_id=${clientId}&tax_year=${taxYear}` +
					(dateRangeStartDate
						? "&date_range_start_date=" + dateRangeStartDate
						: "") +
					(dateRangeEndDate ? "&date_range_end_date=" + dateRangeEndDate : "") +
					`&group_by=${groupBy}&payment_status=${paymentStatus}&expense_category=${expenseCategory}&payment_method=${paymentMethod}&province_of_employment=${provinceOfEmployment}&report_date=${reportDate}&pay_period=${payPeriod}&pay_period_end_date=${payPeriodEndDate}&department=${department}&team=${team}&employee=${employee}` +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/payroll-report/xlsx?client_id=${clientId}&tax_year=${taxYear}` +
				(dateRangeStartDate
					? "&date_range_start_date=" + dateRangeStartDate
					: "") +
				(dateRangeEndDate ? "&date_range_end_date=" + dateRangeEndDate : "") +
				`&group_by=${groupBy}&payment_status=${paymentStatus}&expense_category=${expenseCategory}&payment_method=${paymentMethod}&province_of_employment=${provinceOfEmployment}&report_date=${reportDate}&pay_period=${payPeriod}&pay_period_end_date=${payPeriodEndDate}&department=${department}&team=${team}&employee=${employee}` +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// WSIB ONTARIO Export

	exportWSIBOntarioReport: async (
		event: string,
		clientId: string,
		taxYear: number,
		groupBy: string | number,
		department: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			// http://127.0.0.1:8000/v1/wsib-ontario-report/pdf?client_id=6a0415ce48bfe06851fe9ec1&tax_year=2026&group_by=100&department=all&start_date=2026-01-31&end_date=2026-01-31&order_by=name&order_direction=asc&page=1&size=50
			const url =
				`/v1/wsib-ontario-report/pdf?client_id=${clientId}&tax_year=${taxYear}&group_by=${groupBy}&department=${department}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/wsib-ontario-report/csv?client_id=${clientId}&tax_year=${taxYear}&group_by=${groupBy}&department=${department}` +
					(startDate ? "&start_date=" + startDate : "") +
					(endDate ? "&end_date=" + endDate : "") +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/wsib-ontario-report/xlsx?client_id=${clientId}&tax_year=${taxYear}&group_by=${groupBy}&department=${department}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// time sheet Report Export //

	exportTimeSheetReport: async (
		event: string,
		clientId: string,
		employeeStatus: string | number,
		employeeId: string,
		startDate: string | null,
		endDate: string | null,
		dateRange: boolean,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		if (event === "PDF") {
			const url =
				`/v1/time-sheet-report-printing/pdf?client_id=${clientId}&employee_status=${employeeStatus}&employee_id=${employeeId}` +
				(dateRange && startDate ? "&start_date=" + startDate : "") +
				(dateRange && endDate ? "&end_date=" + endDate : "") +
				"&date_range=" +
				(dateRange ? "true" : "false") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/time-sheet-report-printing/csv?client_id=${clientId}&employee_status=${employeeStatus}&employee_id=${employeeId}` +
					(dateRange && startDate ? "&start_date=" + startDate : "") +
					(dateRange && endDate ? "&end_date=" + endDate : "") +
					"&date_range=" +
					(dateRange ? "true" : "false") +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/time-sheet-report-printing/xlsx?client_id=${clientId}&employee_status=${employeeStatus}&employee_id=${employeeId}` +
				(dateRange && startDate ? "&start_date=" + startDate : "") +
				(dateRange && endDate ? "&end_date=" + endDate : "") +
				"&date_range=" +
				(dateRange ? "true" : "false") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	// statutory Holiday Report Export //

	exportStatutoryHolidayReport: async (
		event: string,
		clientId: string,
		provinceId: string,
		holidayDate: string,
		employeeId: string,
		payPeriodEndDate: string,
		payPeriod: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
		console.log("payPeriod", payPeriod);
		console.log("payPeriodEndDate", payPeriodEndDate);
		if (event === "PDF") {
			const url =
				`/v1/holiday-pay-report/pdf?client_id=${clientId}&province_id=${provinceId}&holiday_date=${holidayDate}&employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&pay_period=${payPeriod}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/holiday-pay-report/csv?client_id=${clientId}&province_id=${provinceId}&holiday_date=${holidayDate}&employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&pay_period=${payPeriod}` +
					(startDate ? "&start_date=" + startDate : "") +
					(endDate ? "&end_date=" + endDate : "") +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/holiday-pay-report/xlsx?client_id=${clientId}&province_id=${provinceId}&holiday_date=${holidayDate}&employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&pay_period=${payPeriod}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},

	exportInvoiceTransactionDetail: async (
		clientId: string,
		invoiceId: string,
	): Promise<any | IServerError | IResponse | any> => {
		// if (event === "PDF") {
		const url = `/v1/transaction-log/by-invoice-detail/pdf-print?client_id=${clientId}&invoice_id=${invoiceId}`;
		const response: any = await http.get(url, {
			responseType: "arraybuffer",
		});

		if (response.status === 201) {
			return response.data;
		} else if (response.status === 200) {
			return response.data;
		} else if (response.status === 400) {
			const text = new TextDecoder().decode(response.data);
			const responseObject = JSON.parse(text);
			let response400 = {
				...response,
				data: responseObject,
			};
			return response400;
		} else if (response.status === 400) {
			return {
				status: false,
				message: "Bad Request.",
				error: true,
			};
		} else if (response.status === 500) {
			return {
				status: false,
				message: "Something went wrong.",
				error: true,
			};
		}

		return {
			status: false,
			message: "Something went wrong please try again later.",
		};
		// }
	},

	emailInvoiceTransactionDetail: async (
		clientId: string,
		invoiceId: string,
		email: string,
	): Promise<
		any | IServerError | IResponse | null
	> => {
		try {
			const response: AxiosResponse<any> =
				await http.get<any>(
					`/v1/transaction-log/by-invoice-detail/pdf-print/email?client_id=${clientId}&invoice_id=${invoiceId}&email=${email}`,
				);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				// navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	// vacation pay Report Export //

	exportVacationPayReport: async (
		event: string,
		clientId: string,
		provinceId: string,
		holidayDate: string,
		employeeId: string,
		payPeriodEndDate: string,
		payPeriod: string,
		startDate: string | null,
		endDate: string | null,
		data: IGetListRequest,
	): Promise<any | IServerError | IResponse | any> => {
	
		if (event === "PDF") {
			const url =
				`/v1/vacation-pay-report/pdf?client_id=${clientId}&province_id=${provinceId}&holiday_date=${holidayDate}&employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&pay_period=${payPeriod}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else if (event === "CSV") {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/vacation-pay-report/csv?client_id=${clientId}&province_id=${provinceId}&holiday_date=${holidayDate}&employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&pay_period=${payPeriod}` +
					(startDate ? "&start_date=" + startDate : "") +
					(endDate ? "&end_date=" + endDate : "") +
					`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 201) {
				return response.data;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} else {
			const url =
				`/v1/vacation-pay-report/xlsx?client_id=${clientId}&province_id=${provinceId}&holiday_date=${holidayDate}&employee_id=${employeeId}&pay_period_end_date=${payPeriodEndDate}&pay_period=${payPeriod}` +
				(startDate ? "&start_date=" + startDate : "") +
				(endDate ? "&end_date=" + endDate : "") +
				`&order_by=${data.order_by}&order_direction=${data.order_direction}&page=${data.page}&size=${data.size}`;
			const response: any = await http.get(url, {
				responseType: "arraybuffer",
			});

			if (response.status === 201) {
				return response.data;
			} else if (response.status === 200) {
				return response.data;
			} else if (response.status === 400) {
				const text = new TextDecoder().decode(response.data);
				const responseObject = JSON.parse(text);
				let response400 = {
					...response,
					data: responseObject,
				};
				return response400;
			} else if (response.status === 400) {
				return {
					status: false,
					message: "Bad Request.",
					error: true,
				};
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		}
	},
};
